import React from 'react';
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryBase from "../components/EntryBase";
import EntryInput from "../components/EntryInput";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {
    isEmpty, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata,
    getformid, getcontroller, getsubkey, initializedata, isEnabled
} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, setmenuinfo } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

const AUX_CONTROLLER = "AuxMatBulk";
const FORM_ID = "AuxMatBulk";
const APPLICATION_TITLE = "副資材一括登録";
const BASE_PANEL_ID = "0";
// 設定データ上のtypeを固定で判定する。列構成で判定すると、対象品番情報(type 100)のように
// 同じD_SSDZ列を含むパネルへ誤って操作部品が表示されるため。
const TARGET_INFO_PANEL_TYPE = "100";
const TARGET_SUPPLIER_FIELD = "SSDZ_TORCODE";
const KOMONO_TRIGGER_FIELD = "SSDZ_KOMONOFUDACD";
const KOMONO_PANEL_TYPE = "103";
const USED_AUX_MATERIAL_PANEL_TYPE = "101";
const USED_MATERIAL_CURRENCY_FIELD = "SSDZM_CUR";
const USED_MATERIAL_RATE_FIELD = "SSDZM_MITUMORIRATE";
const USED_MATERIAL_QTY_FIELD = "SSDZM_YOJAKUKOSU";
const USED_MATERIAL_LOSS_RATE_FIELD = "SSDZM_LOSSRITU";
const USED_MATERIAL_LOSS_QTY_FIELD = "SSDZM_LSURYO";
const USED_MATERIAL_UNIT_PRICE_FIELD = "SSDZM_TANKA";
const USED_MATERIAL_UNIT_PRICE_FOREIGN_FIELD = "SSDZM_TANKAF";
// 金額と金額（外）はD_SSDZMの保存列ではなく、table="-"の画面計算項目。
// s_layoutで定義されたcolumnidをそのまま使用し、列名・表示名から推測しない。
const USED_MATERIAL_AMOUNT_FIELD = "kingaku";
const USED_MATERIAL_AMOUNT_FOREIGN_FIELD = "kingakuF";
const USED_MATERIAL_RECALC_FIELDS = [
    USED_MATERIAL_QTY_FIELD,
    USED_MATERIAL_LOSS_RATE_FIELD,
    USED_MATERIAL_LOSS_QTY_FIELD,
    USED_MATERIAL_UNIT_PRICE_FIELD,
    USED_MATERIAL_UNIT_PRICE_FOREIGN_FIELD
];
const AUX_MATERIAL_PANEL_TYPE = "102";
const BULK_SETTING_PANEL_TYPE = "107";
const BULK_SIKYU_KBN_FIELD = "AUXMATBULK_SIKYUKBN_BULK";
const AUX_MATERIAL_INPUT_PANEL_TYPES = ["102", "103", "104", "105", "106"];
// type=102 は s_logp_id=0 の EntryBase 形式で、ag-grid ではない。
// GridData/SetGridData の対象は表形式(id=2)の 103〜106 に限定する。
const AUX_MATERIAL_GRID_PANEL_TYPES = ["103", "104", "105", "106"];
const AUX_MATERIAL_MASTER_DATA_IDS = ["M_FZK", "FM_FZK"];

// 副資材入力欄から使用副資材一覧へ集約する対象。
// 仕様書の副資材区分と、D_SSDZの入力カラムを対応付ける。
const AUX_MATERIAL_FIELDS = [
    { field: "SSDZ_SAGEFUDASIZECD", kbn: "01", label: "下札" },
    { field: "SSDZ_BRANDNAMECD", kbn: "02", label: "ブランドネーム" },
    { field: "SSDZ_SIZENAMECD1", kbn: "03", label: "サイズネーム" },
    { field: "SSDZ_SONOTANAMECD", kbn: "04", label: "その他ネーム" },
    { field: "SSDZ_SIIRUNOCD", kbn: "05", label: "品質シール" },
    { field: "SSDZ_SUKARTOTURICD", kbn: "06", label: "スカート吊り" },
    { field: "SSDZ_SPEAFUKUROCD", kbn: "07", label: "スペア袋" },
    { field: "SSDZ_BINIRUFUKUROCD", kbn: "08", label: "ビニール袋" },
    { field: "SSDZ_KAIGAINJICD", kbn: "09", label: "海外印字" },
    { field: "SSDZ_SONOTAFUZOKUCD", kbn: "10", label: "その他副資材" },
    { field: "SSDZ_KOMONOFUDACD", kbn: "11", label: "小物札" },
    { field: "SSDZ_SENTAKUHYOJINO", kbn: "14", label: "洗濯ネーム" }
];

// type=103〜106 は固定行数グリッドです。
// type=103 は「小物区分」「小物札寸法・透過率」の2列、104〜106は1列です。
// 同じアイテム+カラー+グループ内に同じ columnid の行が複数存在するため、
// 内部保持では panel type + 行番号をキーに含めます。
const FIXED_AUX_MATERIAL_GRID_PANELS = {
    "103": { rowCount: 6, fields: ["FZK_KOMONOKBN", "SSDZ_KOMONOSIZERITU"] },
    "104": { rowCount: 3, fields: ["SSDZ_BRANDNAMECD"] },
    "105": { rowCount: 6, fields: ["SSDZ_SONOTANAMECD"] },
    "106": { rowCount: 5, fields: ["SSDZ_SONOTAFUZOKUCD"] }
};

// 副資材一括登録画面全体を構成し、画面設定取得、入力状態管理、一覧反映を統括する。
export const AuxMatBulk = props => {
    const panelsdef = [];
    const formid = getformid(FORM_ID, props.location.search);
    const controller = getcontroller(AUX_CONTROLLER, props.location.search);
    const subkey = getsubkey(props.location.search);

    // Reduxから、API呼び出しと画面制御に必要なログイン情報・フォーム状態を取得する。
    const corpkey = useSelector(state => state.user.corpkey);       // 接続先法人キー
    const account = useSelector(state => state.user.account);       // ログインアカウント
    const staff = useSelector(state => state.user.accctl);          // 初期値設定に使う担当者情報
    const menuinfo = useSelector(state => state.form.menuinfo);      // メニュー名と画面制御フラグ
    const formListOption = useSelector(state => state.form.listoption); // 一覧選択肢の一時保持項目
    const formstatus = useSelector(state => state.form.status);      // VIEW、ENTRY FORM、COPY FORM等の画面状態
    const gridlist = useSelector(state => state.form.gridlist);      // パネルとグリッドrefの対応一覧

    // Redux更新用dispatchと、MD投入表から渡された現在のクエリ文字列を取得する。
    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);

    // 共通部品、フォーム本体、画面間データを再描画に依存せず保持する。
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);
    const entrydataRef = useRef(null);
    // GetData直後、EntryGridArのGridApi生成前でもパネル上部の独自UIが明細行を参照できるように保持する。
    const detaildataRef = useRef({});
    // 初期行は、MD投入表から渡された SSD_NO を起点に D_SSDNY のアイテム+カラーから作る。
    // 以後の入力内容は、102〜106 の全アイテム+カラー+グループ分をここに保持する。
    const auxAllRowsRef = useRef([]);
    // アイテム+カラー候補はMD投入表由来の初期値で確定し、グループ操作では増減させない。
    // グループ所属行と同じ配列から候補を作ると、最後の所属グループを削除したカラーまで
    // ドロップダウン／グループ編集ダイアログから消えるため、独立した原本として保持する。
    const auxItemColorCatalogRef = useRef([]);
    // 一度初期化した後に全グループを削除して配列が空になっても、初期 detail から再生成しない。
    const auxAllRowsInitializedRef = useRef(false);
    // setState の反映前でも初回表示・グリッド描画時に選択キーを参照できるよう、ref にも保持する。
    const selectedItemColorRef = useRef("");
    const selectedGroupRef = useRef("");
    // 仕入先コードの全行同期中に再度変更イベントが入らないようにする。
    const supplierSyncingRef = useRef(false);
    // 仕入先名称取得中に別コードへ変更された場合、古い応答を反映しないための連番。
    const supplierSyncRequestRef = useRef(0);
    // 小物札変更時の外部トリガー応答が前後した場合、古い応答を反映しないための連番。
    const komonoTriggerRequestRef = useRef(0);
    // 使用副資材一覧の通貨変更後にレート取得応答が前後しても、古い応答を反映しない。
    const usedMaterialRateRequestRef = useRef({});
    // type=107 の一括操作用仮項目を保持する。保存対象ではなく、ボタン横の入力だけで使う。
    const bulkControlDataRef = useRef({});
    // type=102(副資材)はEntryBase形式のため、選択行を反映したときだけ再マウントする。
    const lastAuxBaseDataKeyRef = useRef("");

    // パネルごとのAG Grid API、列API、行データ、列定義を同じindexで管理する。
    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);
    // Redux の gridlist は dispatch 後すぐにはこの render に反映されない。
    // 初回 GetData 直後でも各パネルへ値をセットできるよう、ローカルにも保持する。
    const gridlistRef = useRef([]);

    // React stateには、描画結果へ直接影響するパネル構成・画面設定・選択状態を保持する。
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [bulkSikyuKbn, setBulkSikyuKbn] = useState("");
    const [auxBaseRenderKey, setAuxBaseRenderKey] = useState(0);
    // ロス率一括設定欄は入力中に画面状態を更新しない。ボタン押下時だけDOM値を参照する。
    const bulkLossRateInputRef = useRef(null);
    const [selectedItemColor, setSelectedItemColor] = useState("");
    const [selectedGroup, setSelectedGroup] = useState("");
    const [copyItemColor, setCopyItemColor] = useState("");
    const [copyGroup, setCopyGroup] = useState("");
    const [groupDialogState, setGroupDialogState] = useState({
        open: false,
        mode: "",
        title: "",
        panelType: "",
        itemCd: "",
        colorCd: "",
        groupNo: "",
        sourceItemCd: "",
        sourceColorCd: "",
        sourceGroupNo: "",
        colorOptions: []
    });
    // Show()が一覧選択行から表示対象コードを取り出すときに参照する主キー。
    const [primarykeys,] = useState(["SSD_NO"]);

    const actionurl = {
        "getlist": controller + "/GetListData"
    };

    // MD投入表からクエリ文字列で渡された起動パラメーターを取得する。
    function GetStartupParam() {
        const params = new URLSearchParams(props.location.search || search || "");
        return {
            code: params.get("code") || "",
            tnyNo: params.get("tnyNo") || "",
            ssdNos: params.get("ssdNos") || "",
            oppiCds: params.get("oppiCds") || ""
        };
    }

    // 保存・削除は今回スコープ外。共通ボタンが押されてもDB更新しない。
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "0", action: "DELETE" }
    ];

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ];

    // 再描画用stateを反転し、refに保持した最新データを画面へ反映する。
    function rerender() {
        setUpdata(update ? false : true);
    }
    // 変更中フラグを解除してから、副資材一括登録を開いたブラウザータブを閉じる。
    function CloseCurrentBrowserTab() {
        try {
            fnc.current?.modify?.(false);
        } catch (e) {
            // 変更フラグ解除に失敗しても、Cancel操作ではタブを閉じる処理を優先する。
        }

        try {
            window.open("", "_self");
            window.close();
        } catch (e) {
            console.warn("[AuxMatBulk] window.close failed", e);
        }
    }


    // Redux反映前はローカルrefを使い、現在利用できるグリッド一覧を返す。
    function GridPanelList() {
        if (Array.isArray(gridlistRef.current) && gridlistRef.current.length !== 0) return gridlistRef.current;
        return Array.isArray(gridlist) ? gridlist : [];
    }

    // パネルIDとtypeから、各グリッド用ref配列のインデックスを特定する。
    function GridIndex(panelInfo) {
        if (isEmpty(panelInfo)) return -1;

        const panelId = String(panelInfo.id ?? "");
        const panelType = String(panelInfo.type ?? "");
        const hasType = panelType !== "" && panelType !== "0" && panelType !== "undefined" && panelType !== "null";
        const allowIdFallback = panelInfo.allowIdFallback === true || !hasType;

        const localList = Array.isArray(gridlistRef.current) ? gridlistRef.current : [];
        let found = localList.find(e => String(e.id) === panelId && String(e.type) === panelType);
        if (!isEmpty(found)) return found.index;

        const reduxList = Array.isArray(gridlist) ? gridlist : [];
        found = reduxList.find(e => String(e.id) === panelId && String(e.type) === panelType);
        if (!isEmpty(found)) return found.index;

        // 副資材一括登録では同じ id に type=102〜106 の複数グリッドがぶら下がる。
        // id だけでフォールバックすると type=102 のデータを type=103 等へ書いてしまうため、
        // type が分かっている場合は id 単独検索をしない。
        if (!allowIdFallback) return -1;

        found = localList.find(e => String(e.id) === panelId);
        if (!isEmpty(found)) return found.index;

        found = reduxList.find(e => String(e.id) === panelId);
        if (!isEmpty(found)) return found.index;

        if (!isEmpty(fnc.current)) return fnc.current.gridindex(panelInfo);
        return -1;
    }

    // 指定パネルの行データをrefとAG Gridの両方へ設定する。
    function SetGridData(panelInfo, data) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return;
        if (isEmpty(griddataRefs.current[gidx])) griddataRefs.current[gidx] = createRef();
        griddataRefs.current[gidx].current = data;
    }

    // 指定パネルが現在保持している行データを取得する。
    function GridData(panelInfo) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1 || isEmpty(griddataRefs.current[gidx])) return null;
        return griddataRefs.current[gidx].current;
    }

    // 指定パネルの列定義をローカルrefへ保持する。
    function SetGridColDef(panelInfo, coldef) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1 || isEmpty(gridcolRefs.current[gidx])) return;
        gridcolRefs.current[gidx].current = coldef;
    }

    // 指定パネルのAG Grid APIをローカルrefへ保持する。
    function SetGridApi(panelInfo, api) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1 || isEmpty(gridapiRefs.current[gidx])) return;
        gridapiRefs.current[gidx].current = api;
    }

    // 指定パネルのAG Grid APIを取得する。
    function GridApi(panelInfo) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1 || isEmpty(gridapiRefs.current[gidx])) return null;
        return gridapiRefs.current[gidx].current;
    }

    // dataRefを書き換えた後、EntryGridArへ再読み込みを通知する。
    // dataRef.currentの変更だけでは既に描画済みのag-gridは自動更新されないため、
    // ドロップダウン変更・一括反映など画面上の行を差し替える処理では必ず呼び出す。
    function RefreshGrid(panelInfo, allowFallbackRerender = true) {
        try {
            if (isEmpty(panelInfo)) return;
            const rows = GridData(panelInfo) || [];
            const api = GridApi(panelInfo);

            if (!isEmpty(api)) {
                if (api.setGridOption) {
                    api.setGridOption("rowData", rows);
                    return;
                }
                if (api.setRowData) {
                    api.setRowData(rows);
                    return;
                }
            }

            // ドロップダウン切替時にここへ落ちると、EntryGridAr 側が detail の全行を
            // 一瞬描画してから GridData の選択行へ戻ることがある。
            // 選択切替処理では fallback rerender を禁止し、api が取れている場合だけ反映する。
            if (!allowFallbackRerender) return;

            if (isEmpty(fnc.current)) return;
            const gridId = fnc.current.GridID(panelInfo);
            if (isEmpty(gridId)) return;
            fnc.current.rerenderGrid(gridId);
        } catch (err) {
            console.warn("[AuxMatBulk] RefreshGrid skipped", panelInfo, err);
        }
    }

    // 指定パネルの列APIをローカルrefへ保持する。
    function SetGridColApi(panelInfo, api) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1 || isEmpty(gridcolapiRefs.current[gidx])) return;
        gridcolapiRefs.current[gidx].current = api;
    }

    // 一覧選択肢など画面外で保持する値を、新しいフォームデータへ引き継ぐ。
    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;

        let newdata = { ...target };
        // 一覧選択肢で保持対象となる項目だけを旧データから引き継ぐ。
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
            }
        });

        return newdata;
    }

    // 法人・アカウント確定後に画面設定を取得し、Redux、グリッドref、起動状態を初期化する。
    useEffect(() => {
        // ログイン情報が揃う前はAPIを呼ばず、Redux反映後にuseEffectを再実行する。
        if (isEmpty(corpkey) || isEmpty(account)) return;

        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);

                    let fields = data.colinfo.filter(e => e.logpid === BASE_PANEL_ID);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === BASE_PANEL_ID));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    // グリッドパネルごとにAPI・列・行データ用refを割り当てる。
                    data.panels.filter(e => e.grid).forEach(function (panelInfo) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panelInfo.id, type: panelInfo.type, index: idx });
                        idx++;

                        let totalColumn = data.colinfo.find(e => e.logpid === "T" + panelInfo.id);
                        if (!isEmpty(totalColumn)) {
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panelInfo.id, type: totalColumn.type, index: idx });
                            idx++;
                        }
                    });
                    gridlistRef.current = glist;
                    dispatch(setgridlist(glist));

                    // 初期レイアウト復元が有効な場合だけ、保存済み配置を画面へ適用する。
                    if (data.prelayout) {
                        RestoreLayout(data.panels, fields);
                    }

                    // MD投入表からは別タブ起動になるため、history.stateではなくクエリ文字列を優先して受け取る。
                    let state = props.location.state;
                    const startupParam = GetStartupParam();
                    // history.stateがない別タブ起動では、クエリ文字列からEntry起動状態を作る。
                    if (isEmpty(state) && !isEmpty(startupParam.code)) {
                        state = {
                            status: "ENTRY FORM",
                            code: startupParam.code,
                            data: {
                                AUXMATBULK_TNY_NO: startupParam.tnyNo,
                                AUXMATBULK_SSD_NOS: startupParam.ssdNos,
                                AUXMATBULK_OPPI_CDS: startupParam.oppiCds
                            }
                        };
                    }
                    // クエリにも状態がない場合だけ、ブラウザー履歴に残る画面状態を利用する。
                    if (isEmpty(state) && !isEmpty(window.history.state) && "status" in window.history.state) {
                        state = window.history.state;
                    }
                    locationstate.current = state;
                    if (!isEmpty(state) && "code" in state) {
                        clearform(state.code === "");
                        dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg(isEmpty(data?.errDescription) ? "画面設定の取得に失敗しました。" : data.errDescription);
                    fnc.current.wait(false);
                }
            });
    }, [search, corpkey, account, controller, subkey, dispatch]);

    // ブラウザーのリサイズを監視し、パネル幅の再計算に使う画面サイズを更新する。
    useEffect(() => {
        // ウィンドウサイズ変更時に、レイアウト計算用の画面サイズを更新する。
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 通常画面はMasterLayoutがメニュー設定(menuinfo.name)からヘッダー表示とdocument.titleを設定する。
    // 副資材一括登録はMD投入表から別タブ起動され、メニュー一覧に存在しない環境でも使うため、
    // この画面用のmenuinfoを補完して既存画面と同じ経路でタイトルを表示する。
    useEffect(() => {
        const currentController = String(menuinfo?.controller ?? "");
        const currentSubkey = String(menuinfo?.subkey ?? "");
        const currentName = String(menuinfo?.name ?? "");

        document.title = "KKAP Lite  #" + APPLICATION_TITLE;

        if (currentController === controller && currentSubkey === subkey && currentName === APPLICATION_TITLE) return;

        dispatch(setmenuinfo({
            name: APPLICATION_TITLE,
            category: "",
            controller: controller,
            subkey: subkey,
            ctrls: "",
            remove1: "",
            remove2: ""
        }));
    }, [menuinfo, controller, subkey, dispatch]);

    // メニュー設定の制御文字列から、レイアウトロックとパネル初期折りたたみを反映する。
    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);
    }, [menuinfo]);

    // コピー画面へ遷移したとき、copyclear指定の項目だけを空にして再描画する。
    useEffect(() => {
        if (formstatus !== "COPY FORM" || isEmpty(columninfo)) return;
        // コピー時に引き継がない指定項目だけを空にする。
        columninfo.filter(e => e.copyclear).forEach(function (col) {
            entrydataRef.current[col.columnid] = "";
        });
        rerender();
    }, [formstatus, columninfo]);

    // 起動状態に応じて既存データの表示、または新規フォームの初期化を開始する。
    function callshow() {
        // コードありは既存データ表示、コードなしは新規フォーム初期化へ分岐する。
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code);
        } else {
            clearform(true);
        }
        locationstate.current = null;
    }

    // 各グリッドAPIを保存し、必要なグリッドが揃った時点で初期データを読み込む。
    function onFirstDataRendered(param, panelInfo) {
        SetGridApi(panelInfo, param.api);
        SetGridColApi(panelInfo, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            // 初期表示に必要な全グリッドAPIが生成済みか順番に確認する。
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false;
                    break;
                }
            }
            if (call) callshow();
        }
    }

    // 表示対象の主キーを決定し、フォームを初期化してGetDataを呼び出す。
    function Show(data, pushcode) {
        let code = "";
        // 引数なしの再表示と、一覧行を受け取った表示でコードの決定方法を分ける。
        if (data === undefined) {
            if (!isEmpty(pushcode)) {
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                // 一覧選択行から最初に値が入っている主キーを表示対象コードとして採用する。
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]];
                        break;
                    }
                }
            }
            setedittingcode(code);
        }

        if (isEmpty(columninfo)) return false;
        clearform(code === "");
        LoadData(code);
        return true;
    }

    // バックエンドから対象品番と副資材候補を取得し、各パネルへ初期表示する。
    function LoadData(code) {
        if (code === "") return;

        fnc.current.wait(true);
        const startupData = !isEmpty(locationstate.current) && !isEmpty(locationstate.current.data) ? locationstate.current.data : GetStartupParam();
        fnc.current.postaxios(controller + '/GetData', {
            "code": code,
            "colinfo": columninfo,
            "controller": controller,
            "data": {
                "AUXMATBULK_TNY_NO": startupData.AUXMATBULK_TNY_NO || startupData.tnyNo,
                "AUXMATBULK_SSD_NOS": startupData.AUXMATBULK_SSD_NOS || startupData.ssdNos,
                "AUXMATBULK_OPPI_CDS": startupData.AUXMATBULK_OPPI_CDS || startupData.oppiCds
            }
        },
            {
                onSuccess: function (data) {
                    try {
                        const beforeData = entrydataRef.current;
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = keepListOptionValue(data.data, beforeData);
                        detaildataRef.current = data.detail || {};
                        initializeAuxAllRows(data.detail || {});
                        initializeAuxItemColorCatalog(data.detail || {});

                        // 初回表示直後は、Redux の gridlist がまだこの render に反映されていないことがある。
                        // その場合でも、detaildataRef に保持しておけばパネル上部の独自ドロップダウンで参照できる。
                        const targetGridList = Array.isArray(gridlistRef.current) && gridlistRef.current.length !== 0 ? gridlistRef.current : gridlist;
                        // GetDataで返されたtype別明細を、対応する各グリッドへ設定する。
                        for (let i = 0; i < targetGridList.length; i++) {
                            const detailRows = data.detail[String(targetGridList[i].type)] || data.detail[targetGridList[i].type];
                            // 初期表示で 101 / 103〜106 が空配列の場合も、以前の表示行を残さず明示的にクリアする。
                            // 空配列も有効な結果として扱い、古い行を残さずグリッドを更新する。
                            if (Array.isArray(detailRows)) {
                                SetGridData({ id: targetGridList[i].id, type: targetGridList[i].type }, detailRows);
                            } else if (!isEmpty(detailRows)) {
                                SetGridData({ id: targetGridList[i].id, type: targetGridList[i].type }, detailRows);
                            }
                        }

                        const initialOption = buildItemColorOptions(getAuxAllRows())[0]?.value || "";
                        const initialSelection = resolveValidAuxSelection(getAuxAllRows(), initialOption, "", "itemColor");
                        // 有効な候補が存在する場合だけ、最初のアイテム＋カラーを各パネルへ表示する。
                        if (initialSelection.itemColorValue !== "") {
                            selectedItemColorRef.current = initialSelection.itemColorValue;
                            selectedGroupRef.current = initialSelection.groupNo;
                            setSelectedItemColor(initialSelection.itemColorValue);
                            setSelectedGroup(initialSelection.groupNo);
                            setCopyItemColor(initialSelection.itemColorValue);
                            setCopyGroup(initialSelection.groupNo);
                            applySelectedAuxRowsToPanels(initialSelection.itemColorValue, initialSelection.groupNo);
                        }

                        rerender();
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.wait(false);
                    } catch (error) {
                        fnc.current.warnmsg("副資材一括登録の入力画面データの反映に失敗しました。");
                        dispatch(changestatus("VIEW"));
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data?.errDescription)) msg = data.errDescription;
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            });
    }

    // フォーム、グリッド、内部保持データを初期化し、必要なら設定済み初期値を取得する。
    function clearform(newform) {
        const beforeData = entrydataRef.current;
        auxAllRowsRef.current = [];
        auxItemColorCatalogRef.current = [];
        auxAllRowsInitializedRef.current = false;
        lastAuxBaseDataKeyRef.current = "";
        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
        // 新しいフォームへ移る前に、全グリッドの表示行をクリアする。
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        fnc.current.modify(false);
        // 新規フォームの場合だけ、SQLで定義された動的初期値を取得する。
        if (isEnabled(newform)) {
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        // SQL初期値として返された項目を対応する列設定へ反映する。
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
                        rerender();
                    }
                }, true);
        }
    }

    // 指定パネルtypeについて、保存データへ残す列IDを重複なく収集する。
    function auxSaveColumnIds(type) {
        const ids = [];
        // 重複と空値を除きながら保存対象列IDへ追加する。
        const add = (key) => {
            const id = normalizeCode(key);
            if (id !== "" && !ids.includes(id)) ids.push(id);
        };

        ["SSDZ_NO", "SSDZ_OPPICD", "SSDZ_ITMCITEMCD", "SSDZ_COLORCD", "SSDZ_FUKUSIZAICOLORGRP", "SSDZ_TORCODE", "rowid"].forEach(add);

        const allColumns = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : []);

        allColumns
            .filter(col => normalizeType(col.type) === normalizeType(type))
            .forEach(col => {
                add(col.columnid);
                add(normalizeCode(col.columnid) + "_cd");
                add(normalizeCode(col.columnid) + "_nm");
            });

        return ids;
    }

    // 内部保持している副資材行から、指定パネルtypeの行だけを抽出する。
    function auxRowsForPanelType(type, rows) {
        if (!Array.isArray(rows)) return [];
        const targetType = normalizeType(type);

        // type=102 は EntryBase の行だけ、固定行グリッドは自分の panel type の行だけを送る。
        // 全保持行を全typeへ投影すると、type=102 の小物札が type=103 に混入するなど、
        // 同じ columnid を持つ別パネル同士が保存時に連動してしまう。
        // type=102はEntryBaseの現在行を保存対象へ変換する。
        if (targetType === AUX_MATERIAL_PANEL_TYPE) {
            return rows.filter(row => normalizeType(row?.__AUXMATBULK_PANEL_TYPE) === "");
        }
        // type=103〜106は固定行グリッドの全行を保存対象へ変換する。
        if (isFixedAuxMaterialGridPanel(targetType)) {
            return rows.filter(row => normalizeType(row?.__AUXMATBULK_PANEL_TYPE) === targetType);
        }
        return rows;
    }

    // 画面内部専用項目を除き、保存対象列だけを持つ行へ変換する。
    function projectAuxRowsForSave(type, rows) {
        const panelRows = auxRowsForPanelType(type, rows);
        const ids = auxSaveColumnIds(type);
        if (ids.length === 0) return panelRows.map(row => ({ ...row }));

        return panelRows.map((row, index) => {
            const result = {};
            ids.forEach(id => {
                if (id in row) result[id] = row[id];
            });
            if (isEmpty(result.rowid)) result.rowid = String(index);
            return result;
        });
    }

    // 102〜106の内部保持データを、保存APIへ渡すdetail形式に組み立てる。
    function buildSaveDetail() {
        // 表示中の副資材(type=102)と各グリッド(type=103〜106)の変更を、全行保持用refへ退避してから送信データを作る。
        captureDisplayedAuxRows("buildSaveDetail");

        const detail = {};
        const usedPanel = findUsedAuxMaterialPanel();
        detail[USED_AUX_MATERIAL_PANEL_TYPE] = !isEmpty(usedPanel) ? currentUsedRows(usedPanel).map(row => ({ ...row })) : [];

        const auxRows = getAuxAllRows().map(row => ({ ...row }));
        // 102〜106の初期detailをすべて内部保持配列へ取り込む。
        AUX_MATERIAL_INPUT_PANEL_TYPES.forEach(type => {
            detail[type] = projectAuxRowsForSave(type, auxRows);
        });

        return detail;
    }

    // フォーム本体と一括設定値から、保存APIへ渡すdataを作成する。
    function buildSaveData() {
        const startupData = GetStartupParam();
        return {
            ...(entrydataRef.current || {}),
            AUXMATBULK_TNY_NO: startupData.AUXMATBULK_TNY_NO || startupData.tnyNo,
            AUXMATBULK_SSD_NOS: startupData.AUXMATBULK_SSD_NOS || startupData.ssdNos,
            AUXMATBULK_OPPI_CDS: startupData.AUXMATBULK_OPPI_CDS || startupData.oppiCds
        };
    }

    // 共通保存APIを呼び出すための入力チェックと送信データ組み立てを行う。
    function Save(finallycallback, nocheck) {
        const paramdata = {
            controller: controller,
            data: buildSaveData(),
            detail: buildSaveDetail(),
            images: [],
            files: [],
            colinfo: columninfo,
            code: edittingcode,
            noconfirm: nocheck
        };

        fnc.current.wait(true);
        fnc.current.postaxios(controller + "/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data?.warning) ? data.warning : [];
                    // 警告がなければ保存成功として後処理を呼び、警告ありならメッセージを表示する。
                    if (warnings.length === 0) {
                        fnc.current.modify(false);
                        fnc.current.success("登録しました。");
                        if (typeof finallycallback === "function") finallycallback(data?.data || data?.returnData || data);
                    } else if (isEnabled(data?.confirm)) {
                        const msgs = ["内容を確認しそのまま登録する場合はOK、修正する場合はCancelを選択してください", "　"];
                        warnings.forEach(w => msgs.push("・" + (w.message || w.Message || String(w))));
                        fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                    } else {
                        let msg = warnings.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, warnings);
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    let msg = "登録に失敗しました";
                    if (!isEmpty(data?.errDescription)) msg = data.errDescription;
                    fnc.current.warnmsg(msg);
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        );
    }

    // 共通メニューから要求された操作を、副資材一括登録の画面処理へ振り分ける。
    function MenuAction(action, finallycallback) {
        // ステータスボタンのCancelでは、副資材一括登録用に開いたブラウザタブを閉じる。
        // 実際にCancel操作で渡されるactionは "close"。
        // 閉じる・キャンセル系操作は保存処理を行わずタブを閉じる。
        if (action === "close" || action === "cancel" || action === "Cancel" || action === "CANCEL" || action === "status_cancel") {
            CloseCurrentBrowserTab();
            return;
        }

        LayoutSaveStorage();
        // 保存メニューは現在のフォームと内部保持明細を保存APIへ渡す。
        if (action === "save") {
            Save(finallycallback);
            return;
        }
        if (action === "delete") {
            fnc.current.warnmsg("削除処理は今回の対応対象外です。");
            return;
        }
        // クリアメニューは新規フォーム状態へ戻す。
        if (action === "clear") {
            clearform(true);
            return;
        }
        if (action === "linkfield") {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid === BASE_PANEL_ID) {
                let key = finallycallback.field + "_" + col.type;
                const input = document.getElementById(key);
                if (!isEmpty(input)) {
                    input.focus();
                    input.select();
                }
                Jump(BASE_PANEL_ID, col.type);
                return;
            }
            Jump(col.logpid, col.type);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: col.logpid, type: col.type }));
        }
    }

    // 画面設定の列情報から、有効なcolumnidを持つ定義だけを返す。
    function layoutColumnDefinition(candidate) {
        if (isEmpty(candidate)) return null;
        return !isEmpty(candidate.colinfo) ? candidate.colinfo : candidate;
    }

    // 変更項目に対応する外部トリガー定義を画面設定から取得する。
    function externalTriggerDefinition(columnId) {
        const targetId = normalizeCode(columnId);
        if (targetId === "") return null;

        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : [])
            .concat(Array.isArray(textfields) ? textfields : []);

        // columnsとcolumninfoを順番に確認し、最初に見つかった有効な定義を採用する。
        for (let i = 0; i < sources.length; i++) {
            const def = layoutColumnDefinition(sources[i]);
            if (isEmpty(def)) continue;
            if (normalizeCode(def.columnid) !== targetId) continue;
            if (def.extriggerref || (Array.isArray(def.extrigger) && def.extrigger.length !== 0)) {
                return def;
            }
        }
        return null;
    }

    // 副資材入力パネル一覧から指定typeのパネル定義を取得する。
    function findAuxInputPanelByType(type) {
        const targetType = normalizeType(type);
        const inputPanels = AuxMaterialInputPanelList();
        let target = inputPanels.find(e => auxInputPanelType(e) === targetType);
        if (!isEmpty(target)) return target;

        target = (Array.isArray(panel) ? panel : []).find(e =>
            resolvedPanelType(e) === targetType
        );
        return target || null;
    }

    // 小物札パネルの6行を取得し、行識別用のスロットを補完する。
    function komonoPanelRows(panelInfo) {
        let rows = null;
        const api = GridApi(panelInfo);
        if (!isEmpty(api) && !isEmpty(AGRef.current)) {
            rows = AGRef.current.GetDatasource(api);
        }
        if (!Array.isArray(rows) || rows.length === 0) rows = GridData(panelInfo);
        if (!Array.isArray(rows) || rows.length === 0) {
            rows = selectedRowsForPanel(panelInfo, getSelectedAuxRows());
        }

        return (Array.isArray(rows) ? rows : []).map((row, index) => {
            const slot = normalizeAuxSlot(row?.__AUXMATBULK_SLOT || row?.rowid, index);
            return {
                ...(row || {}),
                __AUXMATBULK_PANEL_TYPE: KOMONO_PANEL_TYPE,
                __AUXMATBULK_SLOT: slot,
                rowid: `AUXMATBULK_${KOMONO_PANEL_TYPE}_${slot}`
            };
        });
    }

    // GetRowMasterDataの応答を小物札パネルの各行へ対応付けて反映する。
    function applyKomonoTriggerResult(panelInfo, currentRows, responseRows, triggerDef) {
        const targets = [];
        const triggers = Array.isArray(triggerDef?.extrigger) ? triggerDef.extrigger : [];
        triggers.forEach(item => {
            const field = normalizeCode(item?.columnid);
            if (field === "" || targets.some(e => e.field === field)) return;
            targets.push({ field: field, triggerclear: item?.triggerclear === true });
        });
        const returned = Array.isArray(responseRows) ? responseRows : [];

        const nextRows = currentRows.map((row, index) => {
            const slot = normalizeAuxSlot(row?.__AUXMATBULK_SLOT || row?.rowid, index);
            const rowid = `AUXMATBULK_${KOMONO_PANEL_TYPE}_${slot}`;
            const response = returned.find(e => normalizeCode(e?.rowid) === rowid)
                || returned.find(e => normalizeCode(e?.__AUXMATBULK_SLOT) === slot)
                || null;
            const next = {
                ...(row || {}),
                __AUXMATBULK_PANEL_TYPE: KOMONO_PANEL_TYPE,
                __AUXMATBULK_SLOT: slot,
                rowid: rowid
            };

            if (isEmpty(response)) return next;

            // 外部トリガー定義に含まれる全反映先項目を現在行へ設定する。
            targets.forEach(target => {
                const field = target.field;
                const cd = field + "_cd";
                const nm = field + "_nm";

                if (Object.prototype.hasOwnProperty.call(response, field)) {
                    next[field] = response[field];
                } else if (target.triggerclear) {
                    next[field] = "";
                }

                if (Object.prototype.hasOwnProperty.call(response, cd)) {
                    next[cd] = response[cd];
                } else if (target.triggerclear) {
                    next[cd] = "";
                }

                if (Object.prototype.hasOwnProperty.call(response, nm)) {
                    next[nm] = response[nm];
                } else if (target.triggerclear) {
                    next[nm] = "";
                }
            });
            return next;
        });

        SetGridData(panelInfo, nextRows);
        if (!isEmpty(detaildataRef.current)) {
            detaildataRef.current[KOMONO_PANEL_TYPE] = nextRows.map(row => ({ ...row }));
        }
        RefreshGrid(panelInfo, false);
        mergeDisplayedAuxGridRows(panelInfo, nextRows, "komono external trigger");
        fnc.current?.modify?.(true);
    }

    // 小物札コードを条件に共通外部トリガーAPIを呼び、小物区分を更新する。
    function executeKomonoExternalTrigger(value) {
        const triggerDef = externalTriggerDefinition(KOMONO_TRIGGER_FIELD);
        const panelInfo = findAuxInputPanelByType(KOMONO_PANEL_TYPE);

        // 設定または対象パネルを取得できない場合だけ、従来の共通通知へフォールバックする。
        // トリガー設定・対象パネル・共通関数のどれかがなければ安全に処理を終了する。
        if (isEmpty(triggerDef) || isEmpty(panelInfo) || isEmpty(fnc.current)) {
            dispatch(entrytriggercall(KOMONO_TRIGGER_FIELD));
            return;
        }

        const rows = komonoPanelRows(panelInfo);
        if (rows.length === 0) return;

        const code = normalizeCode(value ?? entrydataRef.current?.[KOMONO_TRIGGER_FIELD]);
        if (!isEmpty(entrydataRef.current)) {
            entrydataRef.current = {
                ...entrydataRef.current,
                [KOMONO_TRIGGER_FIELD]: code
            };
        }

        // 小物札を空にした場合は、マスタ問合せを行わずトリガー対象列を全行クリアする。
        // 小物札が空にされた場合はAPIを呼ばず、設定対象列を全行クリアする。
        if (code === "") {
            applyKomonoTriggerResult(panelInfo, rows, [], triggerDef);
            return;
        }

        const requestNo = ++komonoTriggerRequestRef.current;
        const requestSelectionKey = selectedAuxKey();
        const parentData = entrydataRef.current || {};
        const requestRows = rows.map((row, index) => {
            const slot = normalizeAuxSlot(row.__AUXMATBULK_SLOT || row.rowid, index);
            const rowid = `AUXMATBULK_${KOMONO_PANEL_TYPE}_${slot}`;
            return {
                ...row,
                ...parentData,
                SSDZ_NO: row.SSDZ_NO,
                SSDZ_OPPICD: row.SSDZ_OPPICD,
                SSDZ_ITMCITEMCD: row.SSDZ_ITMCITEMCD,
                SSDZ_COLORCD: row.SSDZ_COLORCD,
                SSDZ_FUKUSIZAICOLORGRP: row.SSDZ_FUKUSIZAICOLORGRP,
                SSDZ_TORCODE: row.SSDZ_TORCODE,
                PDT_BRDCODE: row.PDT_BRDCODE,
                __AUXMATBULK_PANEL_TYPE: KOMONO_PANEL_TYPE,
                __AUXMATBULK_SLOT: slot,
                rowid: rowid,
                [KOMONO_TRIGGER_FIELD]: code
            };
        });

        try {
            fnc.current.getRowMasterdata(
                [triggerDef],
                Array.isArray(columninfo) ? columninfo : [],
                requestRows,
                data => {
                    try {
                        // 後から開始された小物札検索がある場合は、この古い応答を破棄する。
                        if (requestNo !== komonoTriggerRequestRef.current) return;
                        const currentSelectionKey = selectedAuxKey();
                        if (
                            normalizeCode(currentSelectionKey.itemCd) !== normalizeCode(requestSelectionKey.itemCd)
                            || normalizeCode(currentSelectionKey.colorCd) !== normalizeCode(requestSelectionKey.colorCd)
                            || normalizeGroupNo(currentSelectionKey.groupNo) !== normalizeGroupNo(requestSelectionKey.groupNo)
                        ) return;
                        applyKomonoTriggerResult(panelInfo, rows, data, triggerDef);
                    } finally {
                        fnc.current?.wait?.(false);
                    }
                },
                true
            );
        } catch (err) {
            fnc.current?.wait?.(false);
            console.warn("[AuxMatBulk] 小物札の外部トリガー処理に失敗しました。", err);
        }
    }

    // EntryBaseの項目変更を受け、仕入先同期または共通外部トリガーを開始する。
    function ValueChanged(id, value, edit) {
        const normalizedId = normalizeCode(id);
        if (normalizedId === "") return;

        // EntryGridAr は共通部品のため変更しない。小物札から固定6行への連携だけは、
        // AuxMatBulk 内で共通 GetRowMasterData を呼び、行固有の rowid を維持して反映する。
        // 小物札だけは、再描画による同値通知を除外して専用の外部トリガー処理を行う。
        if (normalizedId === KOMONO_TRIGGER_FIELD) {
            const incomingCode = normalizeCode(value);
            const currentKey = selectedAuxKey();
            const storedBaseRow = baseAuxRows(getAuxAllRows()).find(row => isSameAuxKey(row, currentKey));
            const storedCode = normalizeCode(storedBaseRow?.[KOMONO_TRIGGER_FIELD]);

            // アイテム+カラー/グループ切替時はtype=102のEntryBaseが再マウントされ、
            // 保存済みの小物札コードでもValueChangedが通知される。この通知で外部トリガーを
            // 再実行すると、dbcolumn=NULLのSSDZ_KOMONOSIZERITUが後から空で上書きされる。
            // ユーザー編集ではない同値通知は無視し、コードが実際に変わった場合だけ実行する。
            if (edit !== true && incomingCode === storedCode) return;

            executeKomonoExternalTrigger(incomingCode);
            return;
        }

        const col = externalTriggerDefinition(normalizedId);
        if (!isEmpty(col)) dispatch(entrytriggercall(normalizedId));
    }

    // 対象品番情報にある仕入先コードの列設定を取得する。
    function targetSupplierColumn() {
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : []);
        return sources.find(col =>
            normalizeType(col?.type) === TARGET_INFO_PANEL_TYPE
            && normalizeCode(col?.columnid) === TARGET_SUPPLIER_FIELD
        );
    }

    // 仕入先マスタ検索に必要なキー情報を現在行から作成する。
    function supplierKeyInfo(col, row) {
        const keyinfo = normalizeCode(col?.keyinfo);
        if (keyinfo === "" || keyinfo.indexOf("=") === -1) return "";
        const pair = keyinfo.split("=");
        const targetKey = normalizeCode(pair[0]);
        const sourceKey = normalizeCode(pair.slice(1).join("="));
        if (targetKey === "" || sourceKey === "") return "";
        return targetKey + "=" + normalizeCode(row?.[sourceKey]);
    }

    // 仕入先コードに対応する名称を共通マスタ処理から取得する。
    function supplierNameForCode(code, sourceRow) {
        const supplierCode = normalizeCode(code);
        if (supplierCode === "") return "";

        const rowCode = normalizeCode(
            sourceRow?.[TARGET_SUPPLIER_FIELD + "_cd"]
            || sourceRow?.[TARGET_SUPPLIER_FIELD]
        );
        const rowName = normalizeCode(sourceRow?.[TARGET_SUPPLIER_FIELD + "_nm"]);
        if (rowName !== "" && (rowCode === "" || rowCode === supplierCode)) return rowName;

        const col = targetSupplierColumn();
        const dataid = normalizeCode(col?.dataid);
        const dbcolumn = normalizeCode(col?.dbcolumn);
        if (dataid === "" || dbcolumn === "" || typeof fnc.current?.getMaster !== "function") return "";

        try {
            const master = fnc.current.getMaster(
                dataid,
                supplierCode,
                supplierKeyInfo(col, sourceRow)
            );
            return isEmpty(master) ? "" : normalizeCode(master[dbcolumn]);
        } catch (err) {
            return "";
        }
    }

    // 指定行へ仕入先コード、コード退避値、名称を同時に設定する。
    function setSupplierValue(row, code, name, field = TARGET_SUPPLIER_FIELD) {
        const next = { ...(row || {}) };
        const supplierCode = normalizeCode(code);
        const supplierName = normalizeCode(name);

        next[field] = supplierCode;
        // 仕入先コードを消した場合は、名称も空にして全関連行へ同期する。
        if (supplierCode === "") {
            next[field + "_cd"] = "";
            next[field + "_nm"] = "";
            return next;
        }

        if (supplierName !== "") {
            next[field + "_cd"] = supplierCode;
            next[field + "_nm"] = supplierName;
            return next;
        }

        // 名称未取得の段階で _cd を現在コードにすると、EntryGridAr の valueFormatter が
        // 「変更されていない値」と判定して空の _nm を表示し、共通マスタキャッシュを参照しません。
        // _cd を空にして、共通処理が取得した名称を表示できる状態にします。
        next[field + "_cd"] = "";
        next[field + "_nm"] = "";
        return next;
    }

    // 変更された仕入先コードと名称を、関連する全パネル・内部データへ同期する。
    function applySupplierCodeToAllRows(code, name, sourcePanel) {
        if (supplierSyncingRef.current) return;
        const supplierCode = normalizeCode(code);
        const supplierName = normalizeCode(name);

        supplierSyncingRef.current = true;
        try {
            const targetPanel = (Array.isArray(panel) ? panel : []).find(p =>
                normalizeType(p?.type) === TARGET_INFO_PANEL_TYPE
            ) || sourcePanel;

            if (!isEmpty(targetPanel)) {
                const api = GridApi(targetPanel);
                let rows = null;
                if (!isEmpty(api) && !isEmpty(AGRef.current)) {
                    rows = AGRef.current.GetDatasource(api);
                }
                if (!Array.isArray(rows)) rows = GridData(targetPanel);
                if (!Array.isArray(rows)) rows = (detaildataRef.current || {})[TARGET_INFO_PANEL_TYPE];

                if (Array.isArray(rows)) {
                    const nextRows = rows.map(row => setSupplierValue(row, supplierCode, supplierName));
                    SetGridData(targetPanel, nextRows);
                    if (!isEmpty(detaildataRef.current)) {
                        detaildataRef.current[TARGET_INFO_PANEL_TYPE] = nextRows.map(row => ({ ...row }));
                    }
                    RefreshGrid(targetPanel, false);
                }
            }

            entrydataRef.current = setSupplierValue(entrydataRef.current || {}, supplierCode, supplierName);

            const allRows = getAuxAllRows();
            auxAllRowsRef.current = (Array.isArray(allRows) ? allRows : []).map(row =>
                setSupplierValue(row, supplierCode, supplierName)
            );

            auxItemColorCatalogRef.current = (Array.isArray(auxItemColorCatalogRef.current)
                ? auxItemColorCatalogRef.current
                : []).map(row => setSupplierValue(row, supplierCode, supplierName));

            if (!isEmpty(detaildataRef.current)) {
                // 仕入先コードを全副資材入力パネルの退避データへ同期する。
                AUX_MATERIAL_INPUT_PANEL_TYPES.forEach(type => {
                    const rows = detaildataRef.current[type];
                    if (Array.isArray(rows)) {
                        detaildataRef.current[type] = rows.map(row =>
                            setSupplierValue(row, supplierCode, supplierName)
                        );
                    }
                });
            }

            // 小物札〜その他副資材の表示中行にも同じ仕入先を保持する。
            // 現在表示中の102〜106パネルにも仕入先コードを反映する。
            AuxMaterialInputPanelList().forEach(panelInfo => {
                const rows = GridData(panelInfo);
                if (!Array.isArray(rows)) return;
                const nextRows = rows.map(row => setSupplierValue(row, supplierCode, supplierName));
                SetGridData(panelInfo, nextRows);
                RefreshGrid(panelInfo, false);
            });

            const usedPanel = findUsedAuxMaterialPanel();
            if (!isEmpty(usedPanel)) {
                const usedRows = GridData(usedPanel);
                if (Array.isArray(usedRows) && usedRows.length !== 0) {
                    const nextRows = usedRows.map(row =>
                        setSupplierValue(row, supplierCode, supplierName, "SSDZM_TORCODE")
                    );
                    SetGridData(usedPanel, nextRows);
                    RefreshGrid(usedPanel, false);
                }
            }

            fnc.current?.modify?.(true);
        } finally {
            supplierSyncingRef.current = false;
        }
    }

    // 対象品番情報で変更された仕入先を検索し、古い応答を除外して全行へ同期する。
    function syncSupplierCode(params, panelInfo) {
        const supplierCode = normalizeCode(params?.newValue ?? params?.data?.[TARGET_SUPPLIER_FIELD]);
        const sourceRow = params?.data || {};
        const cachedName = supplierNameForCode(supplierCode, sourceRow);
        const requestNo = ++supplierSyncRequestRef.current;

        // 空コードまたは名称キャッシュ済みの場合は、追加検索せず直ちに同期する。
        if (supplierCode === "" || cachedName !== "") {
            applySupplierCodeToAllRows(supplierCode, cachedName, panelInfo);
            return;
        }

        const col = targetSupplierColumn();
        const dataid = normalizeCode(col?.dataid);
        const dbcolumn = normalizeCode(col?.dbcolumn);
        if (dataid === "" || dbcolumn === "" || typeof fnc.current?.getMasterdata !== "function") {
            console.warn("[AuxMatBulk] 仕入先コードのdataid/dbcolumn設定が不足しています。", col);
            applySupplierCodeToAllRows(supplierCode, "", panelInfo);
            return;
        }
        const rowdata = {
            ...(entrydataRef.current || {}),
            ...sourceRow,
            [TARGET_SUPPLIER_FIELD]: supplierCode
        };
        const others = [{ columnid: TARGET_SUPPLIER_FIELD, dbcolumn: dbcolumn }];

        // 共通のマスタ取得を利用し、名称が確定してから全行へ同期します。
        // wait=false で補助取得時の画面全体オーバーレイは表示しません。
        fnc.current.getMasterdata(
            dataid,
            supplierCode,
            supplierKeyInfo(col, rowdata),
            others,
            rowdata,
            data => {
                if (requestNo !== supplierSyncRequestRef.current) return;
                if (!isEmpty(data) && typeof fnc.current.setMaster === "function") {
                    fnc.current.setMaster(data);
                }
                const name = normalizeCode(data?.[dbcolumn]);
                applySupplierCodeToAllRows(supplierCode, name, panelInfo);
            },
            false
        );
    }

    // 見積レート取得の基準日として使う指示日をフォームデータから取得する。
    function usedMaterialRateDate() {
        const current = entrydataRef.current || {};
        if (normalizeCode(current.SSD_SIJIYMD) !== "") return normalizeCode(current.SSD_SIJIYMD);

        const targetPanel = (Array.isArray(panel) ? panel : []).find(p =>
            normalizeType(p?.type) === TARGET_INFO_PANEL_TYPE
        );
        const targetRows = isEmpty(targetPanel) ? [] : GridData(targetPanel);
        if (Array.isArray(targetRows)) {
            const hit = targetRows.find(row => normalizeCode(row?.SSD_SIJIYMD) !== "");
            if (!isEmpty(hit)) return normalizeCode(hit.SSD_SIJIYMD);
        }
        return "";
    }

    // 使用副資材一覧の行データを更新し、グリッドへ再描画を要求する。
    function rerenderUsedMaterialGrid(panelInfo, rows) {
        SetGridData(panelInfo, rows);
        const gridId = !isEmpty(fnc.current) && typeof fnc.current.GridID === "function"
            ? fnc.current.GridID(panelInfo)
            : "";
        if (gridId !== "" && typeof fnc.current.rerenderGrid === "function") {
            fnc.current.rerenderGrid(gridId);
        } else {
            RefreshGrid(panelInfo);
        }
    }

    // 指定行の通貨単位と見積レートを更新して使用副資材一覧へ戻す。
    function updateUsedMaterialRate(panelInfo, params, currency, rate) {
        const rowId = normalizeCode(params?.data?.rowid || params?.data?.__AUXMATBULK_ROWID);
        const rowIndex = Number.isInteger(params?.node?.rowIndex) ? params.node.rowIndex : -1;
        let rows = GridData(panelInfo);
        if (!Array.isArray(rows)) rows = [];

        const nextRows = rows.map((row, index) => {
            const currentRowId = normalizeCode(row?.rowid || row?.__AUXMATBULK_ROWID);
            const target = rowId !== "" ? currentRowId === rowId : index === rowIndex;
            if (!target) return row;
            return {
                ...row,
                [USED_MATERIAL_CURRENCY_FIELD]: currency,
                [USED_MATERIAL_RATE_FIELD]: rate
            };
        });
        rerenderUsedMaterialGrid(panelInfo, nextRows);
        fnc.current?.modify?.(true);
    }

    // ユーザーが変更した通貨単位を使い、対象行の見積レートを再取得する。
    function refreshUsedMaterialRate(params, panelInfo) {
        const currency = normalizeCode(
            params?.newValue ?? params?.data?.[USED_MATERIAL_CURRENCY_FIELD]
        );
        const rowKey = normalizeCode(
            params?.data?.rowid || params?.data?.__AUXMATBULK_ROWID || params?.node?.rowIndex
        );
        const requestNo = (usedMaterialRateRequestRef.current[rowKey] || 0) + 1;
        usedMaterialRateRequestRef.current[rowKey] = requestNo;

        // 通貨が空の場合は見積レートも空にし、不要なAPI呼び出しを避ける。
        if (currency === "") {
            updateUsedMaterialRate(panelInfo, params, "", "");
            return;
        }
        // 円通貨はDB検索せず、仕様どおり見積レート1を設定する。
        if (currency.toUpperCase() === "JPY") {
            updateUsedMaterialRate(panelInfo, params, currency, "1");
            return;
        }

        fnc.current.postaxios(
            "TSICom/GetRate",
            {
                controller: controller,
                data: {
                    unit: currency,
                    date: usedMaterialRateDate()
                }
            },
            {
                onSuccess: function (data) {
                    if (usedMaterialRateRequestRef.current[rowKey] !== requestNo) return;
                    updateUsedMaterialRate(
                        panelInfo,
                        params,
                        currency,
                        normalizeCode(data?.request)
                    );
                },
                onError: function () {
                    if (usedMaterialRateRequestRef.current[rowKey] !== requestNo) return;
                    updateUsedMaterialRate(panelInfo, params, currency, "");
                }
            },
            true
        );
    }

    // AG Gridのセル変更を受け、パネル別の同期・再計算・共通変更処理を実行する。
    function GridValueChanged(params, panelInfo) {
        storeRowData(panelInfo);

        const field = normalizeCode(params?.colDef?.colinfo?.columnid);
        if (field === "") return;

        // 仕入先コードだけは画面固有の全行同期を行う。
        // それ以外の項目は既存の外部トリガー共通処理へ委ねる。
        // 対象品番情報の仕入先変更だけは、全パネル同期を行う画面固有処理へ分岐する。
        if (
            normalizeType(panelInfo?.type) === TARGET_INFO_PANEL_TYPE
            && field.toUpperCase() === TARGET_SUPPLIER_FIELD
        ) {
            syncSupplierCode(params, panelInfo);
            return;
        }

        if (
            normalizeType(panelInfo?.type) === USED_AUX_MATERIAL_PANEL_TYPE
            && field.toUpperCase() === USED_MATERIAL_CURRENCY_FIELD
        ) {
            // 通貨単位の共通トリガーが設定されている場合は維持しつつ、見積レートだけ再取得する。
            ValueChanged(field);
            refreshUsedMaterialRate(params, panelInfo);
            return;
        }

        if (
            normalizeType(panelInfo?.type) === USED_AUX_MATERIAL_PANEL_TYPE
            && USED_MATERIAL_RECALC_FIELDS.includes(field.toUpperCase())
        ) {
            // 数量/ロス率/ロス込数量/単価/単価(外)の変更時は、変更行だけを再計算する。
            // GridDataはcellValueChanged直後に変更前の値を返す場合があるため、
            // params.data / params.newValueを現在値として計算へ渡す。
            recalculateChangedUsedMaterialRow(panelInfo, params, field);
            ValueChanged(field);
            return;
        }

        ValueChanged(field);
    }

    // 共通トリガーなどで複数行が更新された結果を内部保持データへ反映する。
    function GridRowsValueChanged(columnId, rows, panelInfo) {
        const api = GridApi(panelInfo);
        let currentRows = null;
        if (!isEmpty(api) && !isEmpty(AGRef.current)) {
            currentRows = AGRef.current.GetDatasource(api);
        }
        if (!Array.isArray(currentRows)) currentRows = Array.isArray(rows) ? rows : [];

        if (Array.isArray(currentRows)) {
            SetGridData(panelInfo, currentRows);
        }

        if (
            normalizeType(panelInfo?.type) === USED_AUX_MATERIAL_PANEL_TYPE
            && normalizeCode(columnId).toUpperCase() === USED_MATERIAL_CURRENCY_FIELD
            && Array.isArray(rows)
        ) {
            // MASTER検索選択時はRowValueChanged経由で返るため、変更された行ごとにレートを再取得する。
            // 共通処理で更新された各行を内部保持配列へマージする。
            rows.forEach(changedRow => {
                refreshUsedMaterialRate(
                    {
                        data: changedRow,
                        newValue: changedRow?.[USED_MATERIAL_CURRENCY_FIELD]
                    },
                    panelInfo
                );
            });
        }

        // s_lo_trigger による外部パネル更新結果を、一覧反映や選択切替で使う
        // auxAllRowsRef にも戻します。これにより小物区分・寸法/透過率の共通処理を維持します。
        if (isAuxMaterialInputPanel(panelInfo)) {
            mergeDisplayedAuxGridRows(
                panelInfo,
                currentRows,
                "common RowValueChanged " + normalizeCode(columnId)
            );
        }
    }

    // 基底パネルまたはグリッドパネルの表示列設定を更新する。
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        // 変更された列一覧をtypeごとに基底入力欄とグリッドへ振り分ける。
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    // 指定パネルの表示・非表示を切り替える。
    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let target = newpanel.find(e => e.id === id && e.type === type);
        if (isEmpty(target)) return;
        target.hide = !show;
        setpanel(newpanel);
    }

    // 副資材固定行グリッドの現在値を、全選択肢分の内部保持データへマージする。
    function mergeDisplayedAuxGridRows(panelInfo, rows, reason) {
        if (!isAuxMaterialInputPanel(panelInfo)) return;
        const currentKey = selectedAuxKey();
        const validSelection = baseAuxRows(getAuxAllRows()).some(row => isSameAuxKey(row, currentKey));
        if (!validSelection) return;

        // グリッドAPIが選択切替直後の旧行を返すことがある。
        // 現在選択中のキーと一致する行だけを退避し、削除済みグループの復活を防ぐ。
        const currentRows = (Array.isArray(rows) ? rows : []).filter(row => isSameAuxKey(row, currentKey));
        if (currentRows.length === 0) return;
        const panelType = auxInputPanelType(panelInfo);
        mergeAuxRowsToAll(currentRows, auxPanelColumnIds(panelType), null, reason, panelType);
    }

    // 現在表示中のパネル値を、画面切替前に内部保持データへ退避する。
    function storeRowData(panelInfo) {
        if (panelInfo === undefined) {
            GridPanelList().forEach(panel => {
                const api = GridApi(panel);
                if (isEmpty(api) || isEmpty(AGRef.current)) return;
                const rows = AGRef.current.GetDatasource(api);
                SetGridData(panel, rows);
                mergeDisplayedAuxGridRows(panel, rows, "store all grid panel");
            });
            return;
        }

        const api = GridApi(panelInfo);
        if (isEmpty(api) || isEmpty(AGRef.current)) return;
        const rows = AGRef.current.GetDatasource(api);
        SetGridData(panelInfo, rows);
        mergeDisplayedAuxGridRows(panelInfo, rows, "store grid panel");
    }

    // リンク項目から別画面へ遷移するため、対象項目へフォーカスして共通処理を呼ぶ。
    function Jump(id, type) {
        let panelid = "basepanel" + type;
        if (isEmpty(type)) type = tabletype(id);
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        EntrybodyRef.current.scrollTop = elem.offsetTop - 50;
    }

    // 基底パネルの表示対象列をtypeで切り替える。
    function SetBaseField(type) {
        dispatch(addentrylayout(type));
    }

    // 保存済みレイアウトを各パネルと基底入力欄へ復元する。
    function RestoreLayout(panels, fields) {
        RestorePanel(panels);
        RestoreBase(fields);
    }

    // 保存済みのパネル順序・表示状態を現在のパネル定義へ反映する。
    function RestorePanel(panelData) {
        let st = Getstorage(formid + "_panel");
        if (isEmpty(st)) return;
        let panelStorage = JSON.parse(st);
        let newpanel = DeepCopy(panelData);
        let sortpanel = [];
        // 保存済みの順序に従って、現在存在するパネルだけを並べ直す。
        for (let i = 0; i < panelStorage.length; i++) {
            let p = newpanel.find(e => e.id === panelStorage[i].id && e.type === panelStorage[i].type);
            if (isEmpty(p)) continue;
            p.hide = panelStorage[i].hide;
            sortpanel.push(p);
        }
        newpanel.filter(e => !sortpanel.some(s => s.id === e.id && s.type === e.type)).forEach(e => sortpanel.push(e));
        setpanel(sortpanel);
    }

    // 保存済みの基底入力欄レイアウトを復元する。
    function RestoreBase(fields) {
        let st = Getstorage(formid + "_basefields");
        if (isEmpty(st)) return;
        let colStorage = JSON.parse(st);
        let newfields = [];
        // 保存済みの基底項目順に従って、現在存在する列だけを並べ直す。
        for (let i = 0; i < colStorage.length; i++) {
            let column = fields.find(e => e.columnid === colStorage[i].columnid && e.type === colStorage[i].type);
            if (!isEmpty(column)) newfields.push(column);
        }
        fields.filter(e => !newfields.some(s => s.columnid === e.columnid && s.type === e.type)).forEach(e => newfields.push(e));
        settextfields(newfields);
    }

    // 現在のパネル配置と入力欄配置をローカルストレージへ保存する。
    function LayoutSaveStorage() {
        let p = [];
        panel.forEach(e => p.push({ id: e.id, type: e.type, hide: e.hide }));
        Savestorage(formid + "_panel", JSON.stringify(p));
        let f = [];
        textfields.forEach(e => f.push({ columnid: e.columnid, type: e.type }));
        Savestorage(formid + "_basefields", JSON.stringify(f));
    }

    // 現在のレイアウトを共通APIへ保存する。
    function SaveLayout(layoutid) {
        LayoutSaveStorage();
        storeRowData();
        let savepanel = [];
        panel.forEach(e => savepanel.push({ id: e.id, type: e.type, hide: e.hide }));
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                columns: columns,
                panels: savepanel,
            },
            {
                onSuccess: function (data) {
                    dispatch(setentrylayout(data.layouts));
                    dispatch(setentrystartup({
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        prelayout: data.prelayout,
                        fitColumn: false
                    }));
                    fnc.current.success();
                    fnc.current.wait(false);
                }
            });
    }

    // 選択した保存済みレイアウトを共通APIから削除する。
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    dispatch(setentrylayout(data.layouts));
                    if (data.layouts.length === 0) {
                        dispatch(setentrystartup({ initlayout: " ", prelayout: false, fitColumn: false }));
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                }
            });
    }

    // 選択した保存済みレイアウトを取得して画面へ反映する。
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    // 呼び出したレイアウトの列定義を各グリッドへ順番に適用する。
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === BASE_PANEL_ID));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                }
            });
    }

    // パネルIDとtypeから共通部品へ渡すテーブル種別を決定する。
    function tabletype(id, type) {
        if (!isEmpty(type)) return type;
        if (id.substr(0, 1) === "T") {
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        }
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    // 指定パネルが副資材一括登録では使用しない空パネルか判定する。
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true;
            if (!isEmpty(type) && !panel.some(e => e.id === id && e.type === type)) return true;
            if (id === BASE_PANEL_ID) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id, type);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }

    // パネルの設定と画面状態から、現在非表示にするか判定する。
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        // type=107 は「支給区分一括設定」など、ボタン横に埋め込んで使う操作用type。
        // 通常パネルとしては表示しない。
        if (normalizeType(p.type) === BULK_SETTING_PANEL_TYPE) return true;
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    // 表示中パネル数に応じて、パネルナビゲーションの幅を計算する。
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    // type値を比較可能な文字列へ正規化する。
    function normalizeType(value) {
        const text = normalizeCode(value);
        if (text.match(/^\d+\.0$/)) return text.replace(/\.0$/, "");
        return text;
    }

    // パネル定義から表示用IDを文字列で取得する。
    function panelIdOf(panelInfo) {
        return normalizeCode(panelInfo?.id);
    }

    // パネル定義に明示されたtypeを取得する。
    function rawPanelType(panelInfo) {
        return normalizeType(panelInfo?.type);
    }

    // auxType、type、logpidの順でパネルtypeを確定する。
    function resolvedPanelType(panelInfo) {
        if (isEmpty(panelInfo)) return "";

        const auxType = normalizeType(panelInfo.auxType);
        // 画面固有で補完したauxTypeがある場合は、それを最優先する。
        if (auxType !== "") return auxType;

        const directType = rawPanelType(panelInfo);
        const panelId = panelIdOf(panelInfo);
        if (panelId === "") return directType === "0" ? "" : directType;

        const types = [];
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : []);
        // 候補となる列設定から、同じパネルIDに属するtypeを重複なく収集する。
        sources.forEach(col => {
            const logpid = normalizeCode(col?.logpid).replace(/^T/, "");
            const type = normalizeType(col?.type);
            if (logpid === panelId && type !== "" && !types.includes(type)) types.push(type);
        });

        // logpidからtypeを一意に決定できる場合だけ設定値を採用する。
        // 複数typeが同じlogpidを共有する場合は、panel.typeをそのまま使用する。
        // logpidからtypeが一意に決まる場合だけ、そのtypeを採用する。
        if (types.length === 1) return types[0];
        return directType === "0" ? "" : directType;
    }

    // パネルが指定したtypeか判定する。
    function isPanelType(panelInfo, type) {
        return resolvedPanelType(panelInfo) === normalizeType(type);
    }

    // パネルが副資材入力の基底パネルtype=102か判定する。
    function isAuxMaterialPanel(panelInfo) {
        return isPanelType(panelInfo, AUX_MATERIAL_PANEL_TYPE);
    }

    // 副資材入力パネルとして扱えるtypeを取得する。
    function auxInputPanelType(panelInfo) {
        const type = resolvedPanelType(panelInfo);
        return AUX_MATERIAL_INPUT_PANEL_TYPES.includes(type) ? type : "";
    }

    // パネルが102〜106の副資材入力パネルか判定する。
    function isAuxMaterialInputPanel(panelInfo) {
        return auxInputPanelType(panelInfo) !== "";
    }

    // 同一typeの重複を避けて、副資材入力パネル一覧へ追加する。
    function appendUniquePanel(list, panelInfo, forceType) {
        if (isEmpty(panelInfo)) return;
        const id = panelIdOf(panelInfo);
        const rawType = rawPanelType(panelInfo);
        const type = normalizeType(forceType || resolvedPanelType(panelInfo));
        if (id === "" || type === "") return;
        if (list.some(e => panelIdOf(e) === id && rawPanelType(e) === rawType && normalizeType(e.auxType ?? resolvedPanelType(e)) === type)) return;
        // typeはGridIndexで使うため、実panel.type(rawType)を壊さない。
        // 論理typeは auxType に保持する。
        list.push({ ...panelInfo, id: id, type: rawType || panelInfo.type, auxType: type });
    }

    // 指定typeの既存グリッド定義を見つけ、副資材入力パネル一覧へ追加する。
    function appendExistingGridPanelByType(list, type) {
        const targetType = normalizeType(type);
        const candidates = []
            .concat(GridPanelList())
            .concat(Array.isArray(panel) ? panel : []);

        candidates
            .filter(e => normalizeType(e.type) === targetType)
            .forEach(e => appendUniquePanel(list, e, targetType));
    }

    // EntryBaseと各固定グリッドから、副資材入力パネル一覧を構成する。
    function AuxMaterialInputPanelList() {
        const list = [];

        // type=102 は GetListTabs 上では id=0 / grid=false の EntryBase パネル。
        // gridlist には存在しないため、ここでは表形式の 103〜106 だけを返す。
        // 固定行グリッドtype=103〜106を表示順に追加する。
        AUX_MATERIAL_GRID_PANEL_TYPES.forEach(type => appendExistingGridPanelByType(list, type));

        (Array.isArray(panel) ? panel : [])
            .filter(e => e.grid && AUX_MATERIAL_GRID_PANEL_TYPES.includes(auxInputPanelType(e)))
            .forEach(e => appendUniquePanel(list, e, auxInputPanelType(e)));

        return list
            .filter(e => GridIndex(e) !== -1)
            .sort((a, b) => Number(resolvedPanelType(a)) - Number(resolvedPanelType(b)));
    }

    // パネルが使用副資材一覧type=101か判定する。
    function isUsedAuxMaterialPanel(panelInfo) {
        // 使用副資材一覧パネルは type 101 固定。
        return isPanelType(panelInfo, USED_AUX_MATERIAL_PANEL_TYPE);
    }

    // 副資材入力の基底パネルtype=102を取得する。
    function findAuxMaterialPanel() {
        const fromPanel = (Array.isArray(panel) ? panel : []).find(e => isAuxMaterialPanel(e));
        if (!isEmpty(fromPanel)) return fromPanel;
        return gridlist.find(e => isAuxMaterialPanel(e));
    }

    // 使用副資材一覧パネルtype=101を取得する。
    function findUsedAuxMaterialPanel() {
        const fromPanel = (Array.isArray(panel) ? panel : []).find(e => isUsedAuxMaterialPanel(e));
        if (!isEmpty(fromPanel)) return fromPanel;
        return gridlist.find(e => isUsedAuxMaterialPanel(e));
    }

    // 支給区分一括設定の列定義を取得する。
    function bulkSikyuKbnColumn() {
        const allColumns = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : []);

        return allColumns.find(e =>
            normalizeType(e.type) === BULK_SETTING_PANEL_TYPE &&
            normalizeCode(e.columnid) === BULK_SIKYU_KBN_FIELD
        );
    }

    // 支給区分のコードと名称を、選択肢データに合わせて正規化する。
    function normalizeBulkSikyuKbnSelection(value, explicitValue = false) {
        const data = bulkControlDataRef.current || {};
        const raw = normalizeCode(explicitValue ? value : data[BULK_SIKYU_KBN_FIELD]);
        const cd = normalizeCode(data[BULK_SIKYU_KBN_FIELD + "_cd"]);
        const nm = normalizeCode(data[BULK_SIKYU_KBN_FIELD + "_nm"]);
        const col = bulkSikyuKbnColumn();
        const options = !isEmpty(col) && Array.isArray(col.options) ? col.options : [];

        // EntryInputが候補行のrowidを返した場合は、同じindexの設定済みoptionだけを採用する。
        const rowidMatch = raw.match(/^rowid(\d+)$/i);
        if (rowidMatch) {
            const opt = options[Number(rowidMatch[1])];
            return isEmpty(opt)
                ? { code: "", name: "" }
                : { code: normalizeCode(opt.code), name: normalizeCode(opt.name) };
        }

        const option = options.find(e => normalizeCode(e.code) === raw);
        if (!isEmpty(option)) {
            return { code: normalizeCode(option.code), name: normalizeCode(option.name) };
        }

        if (!explicitValue && cd !== "") return { code: cd, name: nm };
        return { code: raw, name: normalizeCode(cd) === raw ? nm : "" };
    }

    // 支給区分一括設定の選択値をstateとrefへ同期する。
    function setBulkSikyuKbnSelection(value, explicitValue = false) {
        const selection = normalizeBulkSikyuKbnSelection(value, explicitValue);
        bulkControlDataRef.current = {
            ...(bulkControlDataRef.current || {}),
            [BULK_SIKYU_KBN_FIELD]: selection.code,
            [BULK_SIKYU_KBN_FIELD + "_cd"]: selection.code,
            [BULK_SIKYU_KBN_FIELD + "_nm"]: selection.name
        };
        setBulkSikyuKbn(selection.code);
        return selection;
    }

    // 支給区分一括設定欄の変更値を保持する。
    function BulkSikyuKbnValueChanged(columnid, value) {
        if (normalizeCode(columnid) !== BULK_SIKYU_KBN_FIELD) return;
        // ここでは使用副資材一覧パネルには反映しない。
        // 検索結果が一時的に rowid0〜3 で入る場合だけ、入力欄用の保持値をコード値へ直す。
        setTimeout(() => {
            const current = normalizeCode(bulkControlDataRef.current?.[BULK_SIKYU_KBN_FIELD]);
            setBulkSikyuKbnSelection(!isEmpty(value) ? value : current, true);
        }, 0);
    }

    // nullやundefinedを空文字として扱い、コード値をtrimした文字列へ変換する。
    function normalizeCode(value) {
        return String(value ?? "").trim();
    }

    // 行が指定項目を自分自身のプロパティとして持つか確認する。
    function hasOwnAuxValue(row, field) {
        return !isEmpty(row) && Object.prototype.hasOwnProperty.call(row, field);
    }

    // 計算項目の文字列値を数値へ変換し、変換できない場合は0を返す。
    function usedMaterialCalcNumber(value) {
        const raw = String(value ?? "").replace(/,/g, "").trim();
        if (raw === "") return 0;
        const num = Number(raw);
        return Number.isFinite(num) ? num : 0;
    }

    // table="-"の画面計算項目について、指定されたcolumnidと完全一致する設定だけを参照する。
    // 表示名や類似columnidからの推測は行わない。
    function usedMaterialCalcColumnMeta(columnId) {
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : [])
            .concat(Array.isArray(textfields) ? textfields : []);

        for (let i = 0; i < sources.length; i++) {
            const candidate = sources[i];
            const def = layoutColumnDefinition(candidate);
            if (isEmpty(def)) continue;
            if (normalizeType(def.type) !== USED_AUX_MATERIAL_PANEL_TYPE) continue;
            if (normalizeCode(def.table) !== "-") continue;
            if (normalizeCode(def.columnid) !== columnId) continue;

            const decimalRaw = Number(def.decimalplaces ?? 0);
            return {
                columnId: columnId,
                decimalplaces: Number.isFinite(decimalRaw) ? Math.max(0, decimalRaw) : 0,
                rounding: normalizeCode(def.rounding ?? "0") || "0"
            };
        }

        // 設定取得前でも識別子は固定。金額項目は現行設定に合わせて小数0桁・切捨てとする。
        return {
            columnId: columnId,
            decimalplaces: 0,
            rounding: "0"
        };
    }

    // 列設定に従って計算結果を四捨五入・切上げ・切捨てする。
    function roundUsedMaterialCalc(value, meta, defaultDecimalPlaces = 2) {
        const numeric = usedMaterialCalcNumber(value);
        const decimalRaw = Number(meta?.decimalplaces ?? defaultDecimalPlaces);
        const decimalplaces = Number.isFinite(decimalRaw) ? Math.max(0, decimalRaw) : defaultDecimalPlaces;
        const scale = Math.pow(10, decimalplaces);
        const rounding = normalizeCode(meta?.rounding || "1");
        let rounded;
        if (rounding === "0") {
            rounded = Math.floor(numeric * scale + 1e-9) / scale;
        } else if (rounding === "2") {
            rounded = Math.ceil(numeric * scale - 1e-9) / scale;
        } else {
            rounded = Math.round((numeric + Number.EPSILON) * scale) / scale;
        }
        return Number(rounded.toFixed(decimalplaces));
    }

    // ロス込数量は画面定義のdecimalplace/roundingを適用しない。
    // 画面定義が小数0桁・切捨ての場合でも、ロス率20%の計算結果0.2を保持する必要がある。
    // 浮動小数点誤差だけを除くため、最大6桁で正規化する。
    function recalculateUsedMaterialRow(row, changedField = "") {
        if (isEmpty(row) || typeof row !== "object") return row;
        const next = { ...row };
        const field = normalizeCode(changedField).toUpperCase();
        const recalcAll = field === "" || field === "INITIAL" || field === "REFLECT";
        const recalcLossQty = recalcAll
            || field === USED_MATERIAL_QTY_FIELD
            || field === USED_MATERIAL_LOSS_RATE_FIELD;
        const amountMeta = {
            domestic: usedMaterialCalcColumnMeta(USED_MATERIAL_AMOUNT_FIELD),
            foreign: usedMaterialCalcColumnMeta(USED_MATERIAL_AMOUNT_FOREIGN_FIELD)
        };

        // 画面設計書の指定どおり、要尺は固定値1として扱う。
        // ロス込数量 = 1 * ロス率 / 100
        // 数量またはロス率が変わった場合は、先にロス込数量を再計算する。
        if (recalcLossQty) {
            const lossRate = usedMaterialCalcNumber(next[USED_MATERIAL_LOSS_RATE_FIELD]);
            next[USED_MATERIAL_LOSS_QTY_FIELD] = Number((lossRate / 100).toFixed(6));
        }

        const lossQty = usedMaterialCalcNumber(next[USED_MATERIAL_LOSS_QTY_FIELD]);
        // ロス込数量または単価が変わった場合は、国内金額を再計算する。
        if (
            recalcLossQty
            || recalcAll
            || field === USED_MATERIAL_LOSS_QTY_FIELD
            || field === USED_MATERIAL_UNIT_PRICE_FIELD
        ) {
            const unitPrice = usedMaterialCalcNumber(next[USED_MATERIAL_UNIT_PRICE_FIELD]);
            if (!isEmpty(amountMeta.domestic)) {
                next[amountMeta.domestic.columnId] = roundUsedMaterialCalc(
                    lossQty * unitPrice,
                    amountMeta.domestic,
                    2
                );
            }
        }

        // ロス込数量または外貨単価が変わった場合は、金額（外）を再計算する。
        if (
            recalcLossQty
            || recalcAll
            || field === USED_MATERIAL_LOSS_QTY_FIELD
            || field === USED_MATERIAL_UNIT_PRICE_FOREIGN_FIELD
        ) {
            const unitPriceForeign = usedMaterialCalcNumber(next[USED_MATERIAL_UNIT_PRICE_FOREIGN_FIELD]);
            if (!isEmpty(amountMeta.foreign)) {
                next[amountMeta.foreign.columnId] = roundUsedMaterialCalc(
                    lossQty * unitPriceForeign,
                    amountMeta.foreign,
                    2
                );
            }
        }
        return next;
    }

    // セル変更行を特定し、新しい入力値を使って計算項目を更新する。
    function recalculateChangedUsedMaterialRow(panelInfo, params, changedField) {
        const api = GridApi(panelInfo);
        let rows = null;
        if (!isEmpty(api) && !isEmpty(AGRef.current)) {
            rows = AGRef.current.GetDatasource(api);
        }
        if (!Array.isArray(rows)) rows = GridData(panelInfo);
        if (!Array.isArray(rows)) rows = [];

        const targetRowId = normalizeCode(
            params?.data?.rowid || params?.data?.__AUXMATBULK_ROWID
        );
        const targetIndex = Number.isInteger(params?.node?.rowIndex)
            ? params.node.rowIndex
            : Number.isInteger(params?.rowIndex) ? params.rowIndex : -1;
        const normalizedField = normalizeCode(changedField).toUpperCase();
        const eventRow = { ...(params?.data || {}) };
        if (normalizedField !== "" && params?.newValue !== undefined) {
            eventRow[normalizedField] = params.newValue;
        }

        let targetFound = false;
        const nextRows = rows.map((row, index) => {
            const rowId = normalizeCode(row?.rowid || row?.__AUXMATBULK_ROWID);
            const isTarget = targetRowId !== ""
                ? rowId === targetRowId
                : index === targetIndex;
            if (!isTarget) return row;

            targetFound = true;
            // dataRefの行より、cellValueChangedが渡す現在行を優先する。
            const currentRow = { ...row, ...eventRow };
            if (normalizedField !== "" && params?.newValue !== undefined) {
                currentRow[normalizedField] = params.newValue;
            }
            const calculated = recalculateUsedMaterialRow(currentRow, normalizedField);
            return calculated;
        });

        // rowidが空/重複などで一致しなかった場合も、rowIndexの行を対象に再試行する。
        let finalRows = nextRows;
        if (!targetFound && targetIndex >= 0 && targetIndex < rows.length) {
            finalRows = rows.map((row, index) => {
                if (index !== targetIndex) return row;
                const currentRow = { ...row, ...eventRow };
                if (normalizedField !== "" && params?.newValue !== undefined) {
                    currentRow[normalizedField] = params.newValue;
                }
                return recalculateUsedMaterialRow(currentRow, normalizedField);
            });
            targetFound = true;
        }


        if (!targetFound) return;
        rerenderUsedMaterialGrid(panelInfo, finalRows);
        fnc.current?.modify?.(true);
    }

    // 画面に表示・編集している columnid 本体をコード値の正とする。
    // *_cd は初期取得値の比較・名称表示補助であり、編集後も古い値が残ることがあるため、
    // 本体が明示的に存在する場合は、空文字も含めて本体の値を優先する。
    function auxMaterialCode(row, field) {
        if (isEmpty(row)) return "";
        if (hasOwnAuxValue(row, field)) return normalizeCode(row[field]);
        if (hasOwnAuxValue(row?.materials, field)) return normalizeCode(row.materials[field]);
        if (hasOwnAuxValue(row, field + "_cd")) return normalizeCode(row[field + "_cd"]);
        if (hasOwnAuxValue(row?.materials, field + "_cd")) return normalizeCode(row.materials[field + "_cd"]);
        return "";
    }

    // 副資材項目の列設定を取得する。
    function auxMaterialColumnInfo(field) {
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfields) ? textfields : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : []);

        return sources.find(col =>
            normalizeCode(col?.columnid) === normalizeCode(field)
            && AUX_MATERIAL_INPUT_PANEL_TYPES.includes(normalizeType(col?.type))
        );
    }

    // 共通マスタキャッシュから副資材名称を取得する。
    function auxMaterialMasterName(row, field, code) {
        const col = auxMaterialColumnInfo(field);
        const targetCode = normalizeCode(code);
        const dataid = normalizeCode(col?.dataid);
        const dbcolumn = normalizeCode(col?.dbcolumn);
        if (targetCode === "" || dataid === "" || dbcolumn === "" || typeof fnc.current?.getMaster !== "function") return "";

        let keyinfo = "";
        const rawKeyInfo = normalizeCode(col.keyinfo);
        if (rawKeyInfo !== "" && rawKeyInfo.indexOf("=") >= 0) {
            const parts = rawKeyInfo.split("=");
            const targetKey = normalizeCode(parts[0]);
            const sourceField = normalizeCode(parts.slice(1).join("="));
            if (targetKey !== "" && sourceField !== "") {
                keyinfo = targetKey + "=" + normalizeCode(row?.[sourceField]);
            }
        }

        const master = fnc.current.getMaster(dataid, targetCode, keyinfo);
        return isEmpty(master) ? "" : normalizeCode(master[dbcolumn]);
    }

    // 行の名称項目を優先し、なければ共通マスタから名称を取得する。
    function auxMaterialName(row, field) {
        if (isEmpty(row)) return "";
        const code = auxMaterialCode(row, field);
        if (code === "") return "";

        const directCd = normalizeCode(row[field + "_cd"]);
        const directNm = normalizeCode(row[field + "_nm"]);
        if (directNm !== "" && (directCd === "" || directCd === code)) return directNm;

        const nestedCd = normalizeCode(row?.materials?.[field + "_cd"]);
        const nestedNm = normalizeCode(row?.materials?.[field + "_nm"]);
        if (nestedNm !== "" && (nestedCd === "" || nestedCd === code)) return nestedNm;

        // EntryGridAr は検索選択後の名称を行の *_nm に保持せず、
        // 共通マスタキャッシュから valueFormatter で表示する場合がある。
        const masterName = auxMaterialMasterName(row, field, code);
        if (masterName !== "") return masterName;

        return "";
    }

    // グループ番号を2桁の文字列へ正規化する。
    function normalizeGroupNo(value) {
        const text = normalizeCode(value);
        if (text === "") return "";
        const m = text.match(/^(?:Group)?0*(\d+)$/i);
        if (!m) return text;
        return String(Number(m[1])).padStart(2, "0");
    }

    // グループ番号をドロップダウン表示用ラベルへ変換する。
    function groupNoToLabel(value) {
        const groupNo = normalizeGroupNo(value);
        if (groupNo === "") return "";
        return "Group" + Number(groupNo);
    }

    // アイテム＋カラー選択値をアイテムコードとカラーコードへ分解する。
    function parseItemColorValue(value) {
        const parts = String(value ?? "").split("\u0001");
        return {
            itemCd: normalizeCode(parts[0]),
            colorCd: normalizeCode(parts[1])
        };
    }

    // アイテムコードとカラーコードから選択値を作成する。
    function makeItemColorValue(itemCd, colorCd) {
        return normalizeCode(itemCd) + "\u0001" + normalizeCode(colorCd);
    }

    // 副資材行のアイテム・カラー・グループを結合したキーを作成する。
    function auxRowKey(row) {
        return makeItemColorValue(row?.SSDZ_ITMCITEMCD, row?.SSDZ_COLORCD) + "\u0002" + normalizeGroupNo(row?.SSDZ_FUKUSIZAICOLORGRP);
    }

    // 固定行パネルtypeに対応する行数・列設定を取得する。
    function fixedAuxGridSetting(type) {
        return FIXED_AUX_MATERIAL_GRID_PANELS[normalizeType(type)] || null;
    }

    // パネルが103〜106の固定行グリッドか判定する。
    function isFixedAuxMaterialGridPanel(panelInfoOrType) {
        const type = typeof panelInfoOrType === "string" ? normalizeType(panelInfoOrType) : auxInputPanelType(panelInfoOrType);
        return !isEmpty(fixedAuxGridSetting(type));
    }

    // 対象品番情報(type=100)と使用副資材一覧(type=101)は、
    // ユーザーによる行追加・挿入・削除を許可しない。
    // type=103〜106の固定行パネルも従来どおり同じ制御を使う。
    function isRowOperationLockedPanel(panelInfoOrType) {
        const type = typeof panelInfoOrType === "string"
            ? normalizeType(panelInfoOrType)
            : resolvedPanelType(panelInfoOrType);

        return type === TARGET_INFO_PANEL_TYPE
            || type === USED_AUX_MATERIAL_PANEL_TYPE
            || isFixedAuxMaterialGridPanel(panelInfoOrType);
    }

    // 固定行パネルの行番号を2桁のスロット値へ正規化する。
    function normalizeAuxSlot(value, fallbackIndex = 0) {
        const text = normalizeCode(value);
        if (text !== "") {
            const m = text.match(/(\d+)$/);
            if (m) return String(Number(m[1])).padStart(2, "0");
        }
        return String(Number(fallbackIndex || 0) + 1).padStart(2, "0");
    }

    // 副資材行を内部保持するための一意キーを作成する。
    function auxStorageKey(row) {
        const baseKey = auxRowKey(row);
        const panelType = normalizeCode(row?.__AUXMATBULK_PANEL_TYPE);
        const slot = normalizeAuxSlot(row?.__AUXMATBULK_SLOT, 0);
        if (fixedAuxGridSetting(panelType)) return baseKey + "\u0003" + panelType + "\u0004" + slot;
        return baseKey + "\u0003";
    }

    // 全副資材行から、現在選択中のアイテム・カラー・グループ・パネル行を抽出する。
    function selectedRowsForPanel(panelInfo, selectedRows, selectionKey = null) {
        const panelType = auxInputPanelType(panelInfo);
        const rows = Array.isArray(selectedRows) ? selectedRows : [];
        const setting = fixedAuxGridSetting(panelType);
        if (isEmpty(setting)) {
            return rows.filter(row => normalizeCode(row.__AUXMATBULK_PANEL_TYPE) === "");
        }

        const key = selectionKey || selectedAuxKey();
        const seed = rows.find(row => isSameAuxKey(row, key)) || {};
        const existing = rows
            .filter(row => normalizeCode(row.__AUXMATBULK_PANEL_TYPE) === panelType)
            .sort((a, b) => Number(normalizeAuxSlot(a.__AUXMATBULK_SLOT, 0)) - Number(normalizeAuxSlot(b.__AUXMATBULK_SLOT, 0)));

        const result = [];
        // 固定行パネルの定義行数分、行番号付きの表示行を構成する。
        for (let i = 0; i < setting.rowCount; i++) {
            const slot = String(i + 1).padStart(2, "0");
            const source = existing.find(row => normalizeAuxSlot(row.__AUXMATBULK_SLOT, i) === slot) || {};

            // 固定行パネルは type=102 の seed から入力列を引き継がない。
            // seed はアイテム・カラー・グループ等の共通キー補完にだけ使用し、
            // 小物札などの入力値は当該固定行(source)だけを正とする。
            const nextRow = { ...source };
            nextRow.SSDZ_NO = normalizeCode(source.SSDZ_NO || seed.SSDZ_NO);
            nextRow.SSDZ_OPPICD = normalizeCode(source.SSDZ_OPPICD || seed.SSDZ_OPPICD);
            nextRow.SSDZ_ITMCITEMCD = normalizeCode(source.SSDZ_ITMCITEMCD || seed.SSDZ_ITMCITEMCD || key.itemCd);
            nextRow.SSDZ_COLORCD = normalizeCode(source.SSDZ_COLORCD || seed.SSDZ_COLORCD || key.colorCd);
            nextRow.SSDZ_FUKUSIZAICOLORGRP = normalizeGroupNo(source.SSDZ_FUKUSIZAICOLORGRP || seed.SSDZ_FUKUSIZAICOLORGRP || key.groupNo);
            nextRow.SSDZ_TORCODE = normalizeCode(source.SSDZ_TORCODE || seed.SSDZ_TORCODE || entrydataRef.current?.SSDZ_TORCODE);
            nextRow.PDT_BRDCODE = normalizeCode(source.PDT_BRDCODE || seed.PDT_BRDCODE);
            nextRow.__AUXMATBULK_PANEL_TYPE = panelType;
            nextRow.__AUXMATBULK_SLOT = slot;
            nextRow.rowid = `AUXMATBULK_${panelType}_${slot}`;

            const fixedFields = Array.isArray(setting.fields) ? setting.fields : [];
            // 固定行パネルの各表示項目を、内部保持用の同じ行へコピーする。
            fixedFields.forEach(field => {
                const fixedField = normalizeCode(field);
                if (fixedField === "") return;
                nextRow[fixedField] = source[fixedField] === undefined ? "" : source[fixedField];
                if (source[fixedField + "_cd"] !== undefined) nextRow[fixedField + "_cd"] = source[fixedField + "_cd"];
                else delete nextRow[fixedField + "_cd"];
                if (source[fixedField + "_nm"] !== undefined) nextRow[fixedField + "_nm"] = source[fixedField + "_nm"];
                else delete nextRow[fixedField + "_nm"];
            });

            if (panelType === "103") {
                // 副資材パネルの「小物札」コードは小物札パネルへ直接コピーしません。
                // 小物区分と寸法・透過率は s_lo_trigger の共通処理結果だけを保持します。
                delete nextRow.SSDZ_KOMONOFUDACD;
                delete nextRow.SSDZ_KOMONOFUDACD_cd;
                delete nextRow.SSDZ_KOMONOFUDACD_nm;
            }

            result.push(nextRow);
        }
        return result;
    }

    // 現在選択しているアイテム・カラー・グループを比較用オブジェクトにする。
    function selectedAuxKey(itemColorValue = selectedItemColorRef.current || selectedItemColor, groupValue = selectedGroupRef.current || selectedGroup) {
        const itemColor = parseItemColorValue(itemColorValue);
        return {
            itemCd: itemColor.itemCd,
            colorCd: itemColor.colorCd,
            // どのグループにも属していないカラーは未設定のまま扱う。
            // ここで Group01 に補完すると、削除済みグループを表示・退避する原因になる。
            groupNo: normalizeGroupNo(groupValue)
        };
    }

    // 行が指定されたアイテム・カラー・グループと一致するか判定する。
    function isSameAuxKey(row, key) {
        if (isEmpty(row) || isEmpty(key)) return false;
        return normalizeCode(row.SSDZ_ITMCITEMCD) === normalizeCode(key.itemCd)
            && normalizeCode(row.SSDZ_COLORCD) === normalizeCode(key.colorCd)
            && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === normalizeGroupNo(key.groupNo);
    }

    const AUX_ROW_KEY_FIELDS = ["SSDZ_NO", "SSDZ_OPPICD", "SSDZ_ITMCITEMCD", "SSDZ_COLORCD", "SSDZ_FUKUSIZAICOLORGRP", "SSDZ_TORCODE", "PDT_BRDCODE"];

    // 指定パネルtypeで保持する列IDを画面設定から収集する。
    function auxPanelColumnIds(type) {
        const targetType = normalizeType(type);
        const ids = [];
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfields) ? textfields : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : []);

        sources.forEach(col => {
            if (normalizeType(col?.type) !== targetType) return;
            const id = normalizeCode(col?.columnid);
            if (id === "" || ids.includes(id)) return;
            ids.push(id);
        });

        // アイテム・カラー・グループ等の選択キーを必ず内部保持行へ補完する。
        AUX_ROW_KEY_FIELDS.forEach(id => {
            if (!ids.includes(id)) ids.push(id);
        });

        return ids;
    }

    // 画面行へ選択キーと固定行情報を補い、内部保持用の行を作成する。
    function makeAuxMergeRow(row, columnIds = null, keyOverride = null, panelType = "", rowIndex = 0) {
        const src = row || {};
        const result = {};

        const key = keyOverride || {};
        result.SSDZ_ITMCITEMCD = normalizeCode(key.itemCd || src.SSDZ_ITMCITEMCD);
        result.SSDZ_COLORCD = normalizeCode(key.colorCd || src.SSDZ_COLORCD);
        result.SSDZ_FUKUSIZAICOLORGRP = normalizeGroupNo(key.groupNo || src.SSDZ_FUKUSIZAICOLORGRP);

        const fixedSetting = fixedAuxGridSetting(panelType);
        if (!isEmpty(fixedSetting)) {
            result.__AUXMATBULK_PANEL_TYPE = normalizeType(panelType);
            result.__AUXMATBULK_SLOT = normalizeAuxSlot(src.__AUXMATBULK_SLOT || src.rowid, rowIndex);
        }

        AUX_ROW_KEY_FIELDS.forEach(id => {
            if (id in result) return;
            if (id === "SSDZ_TORCODE") {
                const hasGlobalSupplier = !isEmpty(entrydataRef.current) &&
                    Object.prototype.hasOwnProperty.call(entrydataRef.current, "SSDZ_TORCODE");
                result[id] = normalizeCode(hasGlobalSupplier ? entrydataRef.current.SSDZ_TORCODE : src[id]);
                return;
            }
            if (src[id] !== undefined) result[id] = src[id];
        });

        if (!Array.isArray(columnIds)) {
            return { ...src, ...result };
        }

        // 対象列ごとにコード・コード退避値・名称の整合を取る。
        columnIds.forEach(id => {
            if (AUX_ROW_KEY_FIELDS.includes(id)) return;
            if (id === "rowid" || id === "key") return;
            result[id] = src[id] === undefined ? "" : src[id];
            const cd = id + "_cd";
            const nm = id + "_nm";
            if (src[cd] !== undefined) result[cd] = src[cd];
            if (src[nm] !== undefined) result[nm] = src[nm];
        });

        return result;
    }

    // D_SSDZ のコード本体・_cd・_nm を同じ世代の値にそろえる。
    // EntryInput/EntryGridAr はコード本体だけを更新し、初期取得時の *_cd や *_nm を
    // 行データに残す場合があるため、退避時にここで正規化する。
    function synchronizeAuxMaterialField(target, previous, incoming, field) {
        if (!hasOwnAuxValue(incoming, field)) return;

        const code = normalizeCode(incoming[field]);
        const previousCode = auxMaterialCode(previous || {}, field);
        const previousName = normalizeCode(previous?.[field + "_nm"]);
        const incomingCd = normalizeCode(incoming[field + "_cd"]);
        const incomingName = normalizeCode(incoming?.[field + "_nm"]);

        target[field] = code;
        target[field + "_cd"] = code;

        if (code === "") {
            target[field + "_nm"] = "";
            return;
        }

        let name = auxMaterialMasterName({ ...(previous || {}), ...(incoming || {}), [field]: code, [field + "_cd"]: code }, field, code);

        if (name === "" && incomingName !== "") {
            // *_cd が新コードと一致する場合は当然採用する。
            // EntryBase は名称だけを更新して *_cd を残すことがあるため、コード変更時に
            // 名称も前回から変わっていれば、その名称を新コードの名称として採用する。
            if (incomingCd === code || incomingName !== previousName || code === previousCode) {
                name = incomingName;
            }
        }

        if (name === "" && code === previousCode) name = previousName;
        target[field + "_nm"] = name;
    }

    // 対象列すべてについて副資材コードと名称の同期処理を実行する。
    function synchronizeAuxMaterialFields(target, previous, incoming, columnIds = null) {
        const limited = Array.isArray(columnIds);
        AUX_MATERIAL_FIELDS.forEach(def => {
            if (limited && !columnIds.includes(def.field)) return;
            synchronizeAuxMaterialField(target, previous, incoming, def.field);
        });
        return target;
    }

    // 表示中の副資材行を、全アイテム・カラー・グループ分の内部配列へマージする。
    function mergeAuxRowsToAll(rows, columnIds = null, keyOverride = null, reason = "", panelType = "") {
        if (!Array.isArray(rows) || rows.length === 0) {
            return;
        }
        const before = auxAllRowsRef.current;
        const map = {};
        // 既存行をキー付きMapへ登録し、後続の変更行で上書きできるようにする。
        before.forEach(row => {
            const key = auxStorageKey(row);
            if (auxRowKey(row).replace("\u0002", "") !== "") map[key] = { ...row };
        });
        // 新しい表示行を内部保持形式に変換し、同じキーの既存行へマージする。
        rows.forEach((row, index) => {
            const mergeRow = makeAuxMergeRow(row, columnIds, keyOverride, panelType, index);
            const key = auxStorageKey(mergeRow);
            if (auxRowKey(mergeRow).replace("\u0002", "") === "") return;
            const previous = map[key] || {};
            const merged = { ...previous, ...mergeRow };
            map[key] = synchronizeAuxMaterialFields(merged, previous, mergeRow, columnIds);
        });
        auxAllRowsRef.current = Object.values(map);
    }

    // 初期detailから、グループ操作で消えないアイテム＋カラー候補原本を作成する。
    function initializeAuxItemColorCatalog(detail) {
        const detailRows = (detail || {})[AUX_MATERIAL_PANEL_TYPE]
            || (detail || {})[String(AUX_MATERIAL_PANEL_TYPE)];
        const sourceRows = Array.isArray(detailRows) && detailRows.length !== 0
            ? detailRows
            : baseAuxRows(auxAllRowsRef.current);
        const map = new Map();

        // 初期detailのtype=102行から重複しないアイテム＋カラー候補を作る。
        (Array.isArray(sourceRows) ? sourceRows : []).forEach(row => {
            const itemCd = normalizeCode(row?.SSDZ_ITMCITEMCD);
            const colorCd = normalizeCode(row?.SSDZ_COLORCD);
            if (itemCd === "" || colorCd === "") return;

            const key = makeItemColorValue(itemCd, colorCd);
            const previous = map.get(key) || {};
            const next = { ...previous };
            Object.keys(row || {}).forEach(name => {
                const value = row[name];
                if (next[name] === undefined || normalizeCode(next[name]) === "" || normalizeCode(value) !== "") {
                    next[name] = value;
                }
            });
            next.SSDZ_ITMCITEMCD = itemCd;
            next.SSDZ_COLORCD = colorCd;
            map.set(key, next);
        });

        auxItemColorCatalogRef.current = Array.from(map.values()).sort((a, b) =>
            normalizeCode(a?.SSDZ_ITMCITEMCD).localeCompare(normalizeCode(b?.SSDZ_ITMCITEMCD))
            || normalizeCode(a?.SSDZ_COLORCD).localeCompare(normalizeCode(b?.SSDZ_COLORCD))
        );
    }

    // アイテム＋カラー候補原本を複製して返す。
    function getAuxItemColorCatalog() {
        if (!Array.isArray(auxItemColorCatalogRef.current) || auxItemColorCatalogRef.current.length === 0) {
            initializeAuxItemColorCatalog(detaildataRef.current || {});
        }
        return Array.isArray(auxItemColorCatalogRef.current) ? auxItemColorCatalogRef.current : [];
    }

    // アイテムコードとカラーコードに一致する候補原本を取得する。
    function findAuxItemColorCatalogRow(itemCd, colorCd) {
        const item = normalizeCode(itemCd);
        const color = normalizeCode(colorCd);
        return getAuxItemColorCatalog().find(row =>
            normalizeCode(row?.SSDZ_ITMCITEMCD) === item
            && normalizeCode(row?.SSDZ_COLORCD) === color
        ) || null;
    }

    // 初期detailから102〜106の全副資材行を内部保持配列へ構成する。
    function initializeAuxAllRows(detail) {
        const map = {};
        AUX_MATERIAL_INPUT_PANEL_TYPES.forEach(type => {
            const rows = (detail || {})[String(type)] || (detail || {})[type];
            if (!Array.isArray(rows)) return;
            rows.forEach((row, index) => {
                const prepared = makeAuxMergeRow(row, null, null, fixedAuxGridSetting(type) ? type : "", index);
                const key = auxStorageKey(prepared);
                if (auxRowKey(prepared).replace("\u0002", "") === "") return;
                const previous = map[key] || {};
                const merged = { ...previous, ...prepared };
                map[key] = synchronizeAuxMaterialFields(merged, previous, prepared, null);
            });
        });
        auxAllRowsRef.current = Object.values(map);
        auxAllRowsInitializedRef.current = true;
    }

    // 全副資材行の内部保持データを複製して返す。
    function getAuxAllRows() {
        if (!auxAllRowsInitializedRef.current) initializeAuxAllRows(detaildataRef.current || {});
        return Array.isArray(auxAllRowsRef.current) ? auxAllRowsRef.current : [];
    }

    // 現在選択中のアイテム・カラー・グループに属する行を取得する。
    function getSelectedAuxRows(itemColorValue = selectedItemColorRef.current || selectedItemColor, groupValue = selectedGroupRef.current || selectedGroup) {
        const rows = getAuxAllRows();
        const key = selectedAuxKey(itemColorValue, groupValue);
        if (key.itemCd === "") return [];
        return rows.filter(row => isSameAuxKey(row, key));
    }

    // 選択中のtype=102行をEntryBaseへ設定し、必要な場合だけ再マウントする。
    function applyAuxMaterialBasePanel(row) {
        if (isEmpty(row)) return;

        // type=102 は GetListTabs では id=0/grid=false の EntryBase パネル。
        // EntryGridAr の dataRef ではなく、EntryInput が参照する entrydataRef を更新する。
        const currentData = entrydataRef.current || {};
        const nextData = { ...currentData };
        const auxBaseColumnIds = auxPanelColumnIds(AUX_MATERIAL_PANEL_TYPE);

        // 選択行に存在しない項目は、前回表示していた値を残さず空にする。
        // ここを差し替えではなくマージだけにすると、ドロップダウン切替後も前の値が表示され続ける。
        auxBaseColumnIds.forEach(id => {
            nextData[id] = "";
            delete nextData[id + "_cd"];
            delete nextData[id + "_nm"];
        });
        Object.assign(nextData, row);

        // MASTER(datatype=6) の項目は、既存部品が _cd/_nm を参照する場面がある。
        // コードだけの行でも表示・後続処理が壊れないよう、最低限の表示用値を補完する。
        const baseFields = (Array.isArray(textfields) ? textfields : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : [])
            .filter(e => normalizeType(e.type) === AUX_MATERIAL_PANEL_TYPE);

        baseFields.forEach(col => {
            const key = normalizeCode(col.columnid);
            if (key === "") return;
            const code = normalizeCode(nextData[key]);
            if (code === "") {
                nextData[key + "_cd"] = "";
                nextData[key + "_nm"] = "";
                return;
            }

            nextData[key + "_cd"] = code;
            if (normalizeCode(col.datatype) === "6") {
                const resolvedName = auxMaterialMasterName(nextData, key, code);
                const storedName = normalizeCode(nextData[key + "_nm"]);
                const storedCode = normalizeCode(row?.[key + "_cd"]);
                if (resolvedName !== "") nextData[key + "_nm"] = resolvedName;
                else if (storedName !== "" && (storedCode === "" || storedCode === code)) nextData[key + "_nm"] = storedName;
                else nextData[key + "_nm"] = "";
            }
        });

        const baseKeys = baseFields.map(e => normalizeCode(e.columnid)).filter(e => e !== "");
        ["SSDZ_NO", "SSDZ_OPPICD", "SSDZ_ITMCITEMCD", "SSDZ_COLORCD", "SSDZ_FUKUSIZAICOLORGRP", "SSDZ_TORCODE"].forEach(k => {
            if (!baseKeys.includes(k)) baseKeys.push(k);
        });
        const dataKey = JSON.stringify(baseKeys.reduce((acc, key) => {
            acc[key] = normalizeCode(nextData[key]);
            acc[key + "_cd"] = normalizeCode(nextData[key + "_cd"]);
            acc[key + "_nm"] = normalizeCode(nextData[key + "_nm"]);
            return acc;
        }, {}));

        if (lastAuxBaseDataKeyRef.current === dataKey) return;
        lastAuxBaseDataKeyRef.current = dataKey;
        entrydataRef.current = nextData;

        // entryrerender() は EntryInput の ValueChanged と相互に反応して定期再描画ループになるため使わない。
        // type=102 の EntryBase だけ key を変えて、選択行が変わった時に一度だけ再マウントする。
        setAuxBaseRenderKey(v => v + 1);
    }

    // 選択したアイテム・カラー・グループの102〜106行を各パネルへ表示する。
    function applySelectedAuxRowsToPanels(itemColorValue = selectedItemColor, groupValue = selectedGroup) {
        const selectionKey = selectedAuxKey(itemColorValue, groupValue);
        const selectedRows = getSelectedAuxRows(itemColorValue, groupValue).map(row => ({ ...row }));
        const baseRow = selectedRows.find(row => normalizeType(row.__AUXMATBULK_PANEL_TYPE) === "");
        if (!isEmpty(baseRow)) {
            applyAuxMaterialBasePanel(baseRow);
        } else {
            // 固定行パネルしか存在しない場合でも、その行をtype=102へ流用しない。
            // 共通キーだけを持つ空のEntryBase行を表示し、type=103の小物札値が
            // 副資材パネルへ逆流する経路を遮断する。
            const key = selectedAuxKey(itemColorValue, groupValue);
            const keySource = selectedRows[0] || findAuxItemColorCatalogRow(key.itemCd, key.colorCd) || {};
            applyAuxMaterialBasePanel({
                SSDZ_NO: normalizeCode(keySource.SSDZ_NO),
                SSDZ_OPPICD: normalizeCode(keySource.SSDZ_OPPICD),
                SSDZ_ITMCITEMCD: normalizeCode(key.itemCd),
                SSDZ_COLORCD: normalizeCode(key.colorCd),
                SSDZ_FUKUSIZAICOLORGRP: normalizeGroupNo(key.groupNo),
                SSDZ_TORCODE: normalizeCode(keySource.SSDZ_TORCODE || entrydataRef.current?.SSDZ_TORCODE),
                PDT_BRDCODE: normalizeCode(keySource.PDT_BRDCODE)
            });
        }

        const panels = AuxMaterialInputPanelList();

        // 選択切替前に、各副資材入力パネルの現在値を順番に退避する。
        panels.forEach(panelInfo => {
            try {
                const rows = selectedRowsForPanel(panelInfo, selectedRows, selectionKey).map(row => ({ ...row }));
                SetGridData(panelInfo, rows);
                RefreshGrid(panelInfo, false);
            } catch (err) {
                console.warn("[AuxMatBulk] apply selected rows skipped", panelInfo, err);
            }
        });
    }

    // 現在表示している102〜106の入力値を内部保持データへ退避する。
    function captureDisplayedAuxRows(reason = "") {
        const currentKey = selectedAuxKey();
        const validSelection = baseAuxRows(getAuxAllRows()).some(row => isSameAuxKey(row, currentKey));

        // 削除済みグループなど、内部データに存在しない選択を表示している場合は退避しない。
        // 空の固定行を退避すると、削除済みグループを再生成してしまう。
        if (!validSelection) {
            return;
        }
        // 先に grid パネル(103〜106)を退避し、最後に EntryBase の type=102 を退避する。
        // grid には選択行の全項目が含まれることがあるため、最後に type=102 を反映しないと
        // 下札などの変更が古い grid 行で上書きされる。
        AuxMaterialInputPanelList().forEach(panelInfo => {
            const panelType = auxInputPanelType(panelInfo);
            if (panelType === AUX_MATERIAL_PANEL_TYPE) return;

            const api = GridApi(panelInfo);
            if (!isEmpty(api) && !isEmpty(AGRef.current)) {
                const rows = AGRef.current.GetDatasource(api);
                SetGridData(panelInfo, rows);
                mergeDisplayedAuxGridRows(panelInfo, rows, `capture grid type=${panelType} reason=${reason}`);
            } else {
                const rows = GridData(panelInfo);
                mergeDisplayedAuxGridRows(panelInfo, rows, `capture grid fallback type=${panelType} reason=${reason}`);
            }
        });

        // type=102 は EntryBase のため、現在の入力値を選択中のキーに紐付けて保持する。
        // entrydataRef には対象品番情報(type=100)なども混ざるので、type=102 の列だけを取り込む。
        if (!isEmpty(entrydataRef.current)) {
            mergeAuxRowsToAll(
                [{ ...entrydataRef.current }],
                auxPanelColumnIds(AUX_MATERIAL_PANEL_TYPE),
                selectedAuxKey(),
                `capture entrybase type=102 reason=${reason}`
            );
        }
    }

    // 検証済みの選択結果をstate・ref・各パネルへまとめて反映する。
    function applyResolvedAuxSelection(resolved) {
        const nextItemColor = normalizeCode(resolved?.itemColorValue);
        const nextGroup = normalizeGroupNo(resolved?.groupNo);
        const previousItemColor = normalizeCode(selectedItemColorRef.current || selectedItemColor);
        const previousGroup = normalizeGroupNo(selectedGroupRef.current || selectedGroup);

        // 選択切替前に開始された小物札マスタ取得結果は、新しいアイテム+カラー/グループへ
        // 反映してはいけないため、選択が変わる時点で進行中リクエストを無効化する。
        if (previousItemColor !== nextItemColor || previousGroup !== nextGroup) {
            komonoTriggerRequestRef.current += 1;
        }

        selectedItemColorRef.current = nextItemColor;
        selectedGroupRef.current = nextGroup;
        setSelectedItemColor(nextItemColor);
        setSelectedGroup(nextGroup);
        applySelectedAuxRowsToPanels(nextItemColor, nextGroup);
        return { ...resolved, itemColorValue: nextItemColor, groupNo: nextGroup };
    }

    // 切替前の入力を保存してから、指定したアイテム＋カラーとグループへ移動する。
    function setAuxSelection(itemColorValue, groupValue, changeSource = "auto") {
        captureDisplayedAuxRows("setAuxSelection before change");
        const resolved = resolveValidAuxSelection(getAuxAllRows(), itemColorValue, groupValue, changeSource);
        return applyResolvedAuxSelection(resolved);
    }

    // 複写元として選択したアイテム＋カラーとグループを保持する。
    function setCopySelection(itemColorValue, groupValue, changeSource = "auto") {
        const resolved = resolveValidAuxSelection(getAuxAllRows(), itemColorValue, groupValue, changeSource);
        setCopyItemColor(normalizeCode(resolved.itemColorValue));
        setCopyGroup(normalizeGroupNo(resolved.groupNo));
        return resolved;
    }

    // 副資材パネルの現在行を、内部保持またはグリッドから取得する。
    function currentAuxRows(panelInfo) {
        // ドロップダウン候補や一覧反映の集計元は、明示的に退避済みの auxAllRowsRef に統一する。
        // ここで AG Grid の現在行を読み込んで mergeAuxRowsToAll() すると、
        // レンダリングやドロップダウン表示のたびに古い griddata/detail が内部保持データを上書きし、
        // 一覧反映時に初期表示時の副資材品番が復活する原因になる。
        // 画面表示中の編集内容を内部保持へ戻す必要がある箇所では、
        // setAuxSelection() / ReflectUsedAuxMaterials() / openGroupDialog() などから
        // captureDisplayedAuxRows() を明示的に呼ぶ。
        return getAuxAllRows();
    }

    // 使用副資材一覧の現在行を取得する。
    function currentUsedRows(panelInfo) {
        const usedPanel = !isEmpty(panelInfo) ? panelInfo : findUsedAuxMaterialPanel();
        if (isEmpty(usedPanel)) return [];

        const api = GridApi(usedPanel);
        if (!isEmpty(api) && !isEmpty(AGRef.current)) {
            storeRowData(usedPanel);
        }

        const rows = GridData(usedPanel);
        if (Array.isArray(rows) && rows.length !== 0) return rows;

        const detailRows = (detaildataRef.current || {})[String(usedPanel.type)] || (detaildataRef.current || {})[usedPanel.type];
        return Array.isArray(detailRows) ? detailRows : [];
    }

    // 副資材行からtype=102の基底行だけを抽出する。
    function baseAuxRows(rows = currentAuxRows()) {
        const list = Array.isArray(rows) ? rows : [];
        const seen = {};
        const result = [];
        // 同一内部キーの行を後勝ちで上書きし、重複を除去する。
        list.forEach(row => {
            if (normalizeType(row?.__AUXMATBULK_PANEL_TYPE) !== "") return;
            const itemCd = normalizeCode(row?.SSDZ_ITMCITEMCD);
            const colorCd = normalizeCode(row?.SSDZ_COLORCD);
            const groupNo = normalizeGroupNo(row?.SSDZ_FUKUSIZAICOLORGRP);
            if (itemCd === "" || colorCd === "" || groupNo === "") return;
            const key = makeItemColorValue(itemCd, colorCd) + "\u0002" + groupNo;
            if (seen[key]) return;
            seen[key] = true;
            result.push(row);
        });
        return result;
    }

    // 副資材行をカラーコード順に並べる。
    function sortAuxRowsByColor(rows) {
        return [...(Array.isArray(rows) ? rows : [])].sort((a, b) =>
            normalizeCode(a?.SSDZ_COLORCD).localeCompare(normalizeCode(b?.SSDZ_COLORCD))
            || Number(normalizeGroupNo(a?.SSDZ_FUKUSIZAICOLORGRP)) - Number(normalizeGroupNo(b?.SSDZ_FUKUSIZAICOLORGRP))
        );
    }

    // 副資材行をグループ番号、カラーコード順に並べる。
    function sortAuxRowsByGroup(rows) {
        return [...(Array.isArray(rows) ? rows : [])].sort((a, b) =>
            Number(normalizeGroupNo(a?.SSDZ_FUKUSIZAICOLORGRP)) - Number(normalizeGroupNo(b?.SSDZ_FUKUSIZAICOLORGRP))
            || normalizeCode(a?.SSDZ_COLORCD).localeCompare(normalizeCode(b?.SSDZ_COLORCD))
        );
    }

    // 副資材行から有効なアイテム＋カラー・グループ選択結果を作る。
    function resolvedAuxSelectionFromRow(row) {
        if (isEmpty(row)) return { itemCd: "", colorCd: "", groupNo: "", itemColorValue: "", row: null };
        const itemCd = normalizeCode(row.SSDZ_ITMCITEMCD);
        const colorCd = normalizeCode(row.SSDZ_COLORCD);
        const groupNo = normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP);
        return {
            itemCd,
            colorCd,
            groupNo,
            itemColorValue: itemCd === "" || colorCd === "" ? "" : makeItemColorValue(itemCd, colorCd),
            row
        };
    }

    // 候補原本から、グループ未所属を含む選択結果を作る。
    function resolvedAuxSelectionFromCatalogRow(row, groupNo = "") {
        if (isEmpty(row)) return resolvedAuxSelectionFromRow(null);
        const itemCd = normalizeCode(row.SSDZ_ITMCITEMCD);
        const colorCd = normalizeCode(row.SSDZ_COLORCD);
        return {
            itemCd,
            colorCd,
            groupNo: normalizeGroupNo(groupNo),
            itemColorValue: itemCd === "" || colorCd === "" ? "" : makeItemColorValue(itemCd, colorCd),
            row
        };
    }

    // アイテム+カラーとグループの選択を、実際に存在するtype=102行へ補正する。
    // group: グループを優先し、そのグループ内に現在カラーがなければ先頭カラーへ移動。
    // itemColor: アイテム+カラーを優先し、そのカラーを含むグループへ移動。
    function resolveValidAuxSelection(rows, requestedItemColor = "", requestedGroup = "", changeSource = "auto") {
        const candidates = baseAuxRows(rows);
        const catalog = getAuxItemColorCatalog();
        const requested = parseItemColorValue(requestedItemColor);
        const itemCd = normalizeCode(requested.itemCd);
        const colorCd = normalizeCode(requested.colorCd);
        const groupNo = normalizeGroupNo(requestedGroup);
        const requestedCatalogRow = catalog.find(row =>
            normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
            && normalizeCode(row.SSDZ_COLORCD) === colorCd
        );

        if (candidates.length === 0) {
            return resolvedAuxSelectionFromCatalogRow(requestedCatalogRow || catalog[0], "");
        }

        const exact = candidates.find(row =>
            normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
            && normalizeCode(row.SSDZ_COLORCD) === colorCd
            && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
        );
        if (!isEmpty(exact)) return resolvedAuxSelectionFromRow(exact);

        const itemRows = itemCd === ""
            ? candidates
            : candidates.filter(row => normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd);

        if (changeSource === "group" || changeSource === "mutation") {
            const groupRows = sortAuxRowsByColor(itemRows.filter(row =>
                normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
            ));
            if (groupRows.length !== 0) {
                const sameColor = groupRows.find(row => normalizeCode(row.SSDZ_COLORCD) === colorCd);
                return resolvedAuxSelectionFromRow(sameColor || groupRows[0]);
            }
        }

        // アイテム＋カラー変更では、現在グループに同じカラーがあれば維持する。
        if (changeSource === "itemColor") {
            const colorRows = sortAuxRowsByGroup(itemRows.filter(row =>
                normalizeCode(row.SSDZ_COLORCD) === colorCd
            ));
            if (colorRows.length !== 0) {
                const sameGroup = colorRows.find(row => normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo);
                return resolvedAuxSelectionFromRow(sameGroup || colorRows[0]);
            }
            // カラーがどのグループにも属していなくても、MD投入表由来の候補自体は維持する。
            // グループは未選択とし、追加・編集ダイアログから再所属できるようにする。
            if (!isEmpty(requestedCatalogRow)) return resolvedAuxSelectionFromCatalogRow(requestedCatalogRow, "");
        }

        // 自動補正では、まず指定グループを維持し、次に指定カラーを維持する。
        const groupRows = sortAuxRowsByColor(itemRows.filter(row =>
            normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
        ));
        if (groupRows.length !== 0) {
            const sameColor = groupRows.find(row => normalizeCode(row.SSDZ_COLORCD) === colorCd);
            return resolvedAuxSelectionFromRow(sameColor || groupRows[0]);
        }

        const colorRows = sortAuxRowsByGroup(itemRows.filter(row =>
            normalizeCode(row.SSDZ_COLORCD) === colorCd
        ));
        if (colorRows.length !== 0) return resolvedAuxSelectionFromRow(colorRows[0]);

        if (!isEmpty(requestedCatalogRow) && groupNo === "") {
            return resolvedAuxSelectionFromCatalogRow(requestedCatalogRow, "");
        }
        if (itemRows.length !== 0) return resolvedAuxSelectionFromRow(sortAuxRowsByGroup(itemRows)[0]);
        if (!isEmpty(requestedCatalogRow)) return resolvedAuxSelectionFromCatalogRow(requestedCatalogRow, "");
        return resolvedAuxSelectionFromRow(sortAuxRowsByGroup(candidates)[0]);
    }

    // グループ削除後に表示する次の有効な組合せを決定する。
    function resolveSelectionAfterGroupDelete(rows, itemCd, deletedGroupNo, preferredItemColor) {
        const normalizedItem = normalizeCode(itemCd);
        const deletedGroup = normalizeGroupNo(deletedGroupNo);
        const groups = buildGroupOptions(rows, normalizedItem);
        if (groups.length === 0) {
            return resolveValidAuxSelection(rows, preferredItemColor, "", "itemColor");
        }

        const deletedNumber = Number(deletedGroup);
        let nextGroup = groups.find(group => Number(group) > deletedNumber);
        if (nextGroup === undefined) nextGroup = groups[groups.length - 1];
        return resolveValidAuxSelection(rows, preferredItemColor, nextGroup, "group");
    }

    // 内部保持キーが同じ副資材行を後勝ちで重複排除する。
    function dedupeAuxRows(rows) {
        const map = new Map();
        (Array.isArray(rows) ? rows : []).forEach(row => {
            const key = auxStorageKey(row);
            if (auxRowKey(row).replace("\u0002", "") === "") return;
            map.set(key, row);
        });
        return Array.from(map.values());
    }

    // 候補原本からアイテム＋カラーのドロップダウン選択肢を作る。
    function buildItemColorOptions(rows = currentAuxRows()) {
        const seen = {};
        const result = [];
        const catalog = getAuxItemColorCatalog();
        const sourceRows = catalog.length !== 0 ? catalog : baseAuxRows(rows);
        // 各副資材入力行から一覧反映対象のコードと名称を収集する。
        sourceRows.forEach(row => {
            const itemCd = normalizeCode(row.SSDZ_ITMCITEMCD);
            const colorCd = normalizeCode(row.SSDZ_COLORCD);
            if (itemCd === "" || colorCd === "") return;

            const key = makeItemColorValue(itemCd, colorCd);
            if (seen[key]) return;
            seen[key] = true;
            const itemName = normalizeCode(row.SSDZ_ITMCITEMCD_nm);
            const colorName = normalizeCode(row.SSDZ_COLORCD_nm);
            result.push({
                value: key,
                itemCd,
                colorCd,
                label: `${itemCd} / ${colorCd}${itemName === "" && colorName === "" ? "" : " : " + [itemName, colorName].filter(v => v !== "").join(" / ")}`
            });
        });
        return result;
    }

    // 指定アイテムに存在するグループの選択肢を作る。
    function buildGroupOptions(rows = currentAuxRows(), itemCd = "") {
        const targetItem = normalizeCode(itemCd);
        const seen = {};
        const result = [];
        baseAuxRows(rows).forEach(row => {
            if (targetItem !== "" && normalizeCode(row.SSDZ_ITMCITEMCD) !== targetItem) return;
            const groupNo = normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP);
            if (groupNo === "" || seen[groupNo]) return;
            seen[groupNo] = true;
            result.push(groupNo);
        });
        result.sort((a, b) => Number(a) - Number(b) || a.localeCompare(b));
        return result;
    }

    // グループ編集・複写ダイアログに表示するカラー候補と選択状態を作る。
    function buildColorOptionsForItem(itemCd, checkedGroupNo = "", sourceGroupNo = "", sourceRows = null) {
        const membershipRows = baseAuxRows(Array.isArray(sourceRows) ? sourceRows : currentAuxRows());
        const targetItem = normalizeCode(itemCd);
        const checkedGroup = normalizeGroupNo(checkedGroupNo);
        const sourceGroup = normalizeGroupNo(sourceGroupNo);
        const seen = {};
        const result = [];
        const catalogRows = getAuxItemColorCatalog().filter(row =>
            targetItem === "" || normalizeCode(row.SSDZ_ITMCITEMCD) === targetItem
        );
        const availableRows = catalogRows.length !== 0
            ? catalogRows
            : membershipRows.filter(row => targetItem === "" || normalizeCode(row.SSDZ_ITMCITEMCD) === targetItem);

        // 対象アイテムに存在するカラーを、所属グループと選択状態付きで列挙する。
        availableRows.forEach(row => {
            const rowItem = normalizeCode(row.SSDZ_ITMCITEMCD);
            const colorCd = normalizeCode(row.SSDZ_COLORCD);
            if (rowItem === "" || colorCd === "" || seen[colorCd]) return;

            const belongsToSourceGroup = sourceGroup !== "" && membershipRows.some(r =>
                normalizeCode(r.SSDZ_ITMCITEMCD) === rowItem
                && normalizeCode(r.SSDZ_COLORCD) === colorCd
                && normalizeGroupNo(r.SSDZ_FUKUSIZAICOLORGRP) === sourceGroup
            );
            if (sourceGroup !== "" && !belongsToSourceGroup) return;

            seen[colorCd] = true;
            const colorName = normalizeCode(row.SSDZ_COLORCD_nm);
            const checked = checkedGroup !== "" && membershipRows.some(r =>
                normalizeCode(r.SSDZ_ITMCITEMCD) === rowItem
                && normalizeGroupNo(r.SSDZ_FUKUSIZAICOLORGRP) === checkedGroup
                && normalizeCode(r.SSDZ_COLORCD) === colorCd
            );
            result.push({ colorCd, colorName, checked: sourceGroup !== "" ? true : checked });
        });
        result.sort((a, b) => a.colorCd.localeCompare(b.colorCd));
        return result;
    }

    // 現在の選択を検証し、無効なら存在する組合せへ自動補正する。
    function ensureAuxSelection(panelInfo) {
        const rows = currentAuxRows(panelInfo);
        const itemColorOptions = buildItemColorOptions(rows);
        const requestedItemColor = selectedItemColorRef.current || selectedItemColor || itemColorOptions[0]?.value || "";
        const requestedGroup = selectedGroupRef.current || selectedGroup || "";
        const resolved = resolveValidAuxSelection(rows, requestedItemColor, requestedGroup, "auto");
        const nextItemColor = resolved.itemColorValue;
        const nextGroup = resolved.groupNo;
        const groups = buildGroupOptions(rows, resolved.itemCd);

        const requestedCopyItemColor = copyItemColor || nextItemColor;
        const requestedCopyGroup = copyGroup || nextGroup;
        const copyResolved = resolveValidAuxSelection(rows, requestedCopyItemColor, requestedCopyGroup, "auto");
        const nextCopyItemColor = copyResolved.itemColorValue;
        const nextCopyGroup = copyResolved.groupNo;
        const copyGroups = buildGroupOptions(rows, copyResolved.itemCd);
        return { rows, itemColorOptions, groups, copyGroups, nextItemColor, nextGroup, nextCopyItemColor, nextCopyGroup };
    }

    // 使用副資材一覧の既存行を副資材コード単位のMapに変換する。
    function createExistingUsedMaterialMap(rows) {
        let map = {};
        if (!Array.isArray(rows)) return map;
        // 既存の使用副資材一覧をコード単位で再利用できるMapへ変換する。
        rows.forEach(row => {
            const code = normalizeCode(row.SSDZM_FUZOKU_HINBAN);
            if (code === "") return;
            map[code] = row;
        });
        return map;
    }

    // 一覧反映で収集する副資材項目定義を返す。
    function auxMaterialCollectionFields() {
        // 一覧反映の対象は、固定配列に載っている全D_SSDZ列ではなく、
        // 実際に副資材～その他副資材パネル(type=102～106)へ設定されている
        // M_FZK参照項目だけに限定する。
        // ブランドネーム/その他ネームなどの「内容」列はD_SSDZ上では *_CD に見えるが、
        // 使用副資材品番ではないため、M_FZK参照でない限り一覧反映対象にしない。
        const enabled = {};
        const sources = []
            .concat(Array.isArray(columns) ? columns : [])
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(textfields) ? textfields : [])
            .concat(Array.isArray(textfieldsall) ? textfieldsall : []);

        sources.forEach(col => {
            const type = normalizeType(col?.type);
            if (!AUX_MATERIAL_INPUT_PANEL_TYPES.includes(type)) return;
            const id = normalizeCode(col?.columnid);
            if (id === "") return;
            // hidden=1 の項目は、内部保持用キーなどの可能性があるため一覧反映対象から外す。
            if (normalizeCode(col?.hidden) === "1") return;

            const masterType = normalizeCode(col?.mastertype).toUpperCase();
            const dataId = normalizeCode(col?.dataid).toUpperCase();
            const dataIdCtrl = normalizeCode(col?.dataidctrl).toUpperCase();
            const isFzkMaster = AUX_MATERIAL_MASTER_DATA_IDS.includes(masterType)
                || AUX_MATERIAL_MASTER_DATA_IDS.includes(dataId)
                || AUX_MATERIAL_MASTER_DATA_IDS.includes(dataIdCtrl);
            if (!isFzkMaster) return;

            enabled[id] = true;
        });

        return AUX_MATERIAL_FIELDS.filter(def => enabled[def.field]);
    }

    // 一覧反映対象として必要な品番・仕入先・ブランド情報が揃っているか確認する。
    function isValidAuxMaterialSourceRow(row) {
        // 集計元のD_SSDZ行は、アイテム+カラー+グループの3要素が揃っているものだけに限定する。
        // EntryBaseの一時データや検索リストの行が混ざっても、ここで除外する。
        return normalizeCode(row?.SSDZ_ITMCITEMCD) !== ""
            && normalizeCode(row?.SSDZ_COLORCD) !== ""
            && normalizeGroupNo(row?.SSDZ_FUKUSIZAICOLORGRP) !== "";
    }

    // 102〜106の入力値を副資材コード単位に集約し、使用副資材一覧行を作る。
    function collectAuxMaterials(capture = true) {
        // 一覧反映は、現在表示中の副資材パネル(type=102)とグリッドパネル(type=103～106)の
        // 編集内容を内部保持データへ退避してから、保持済みの全アイテム+カラー/グループを集計する。
        // capture=false は、呼び出し元ですでに captureDisplayedAuxRows() 済みの場合に使う。
        if (capture) captureDisplayedAuxRows("collectAuxMaterials");

        const fields = auxMaterialCollectionFields();
        let result = [];
        let unique = {};
        const sourceRows = getAuxAllRows();

        sourceRows.forEach(row => {
            if (!isValidAuxMaterialSourceRow(row)) return;

            // 1行に含まれる各副資材項目を個別の使用副資材一覧行へ展開する。
            fields.forEach(def => {
                const code = auxMaterialCode(row, def.field);
                if (code === "") return;
                // マスタ検索部品の内部行IDが混入した場合は使用副資材品番として扱わない。
                if (/^rowid\d+$/i.test(code)) return;
                if (unique[code]) return;
                unique[code] = true;
                result.push({
                    code: code,
                    name: auxMaterialName(row, def.field),
                    kbn: def.kbn,
                    label: def.label,
                    sourceItem: normalizeCode(row.SSDZ_ITMCITEMCD),
                    sourceColor: normalizeCode(row.SSDZ_COLORCD),
                    sourceGroup: normalizeCode(row.SSDZ_FUKUSIZAICOLORGRP),
                    sourceTorCode: normalizeCode(row.SSDZ_TORCODE),
                    sourceBrandCode: normalizeCode(row.PDT_BRDCODE)
                });
            });
        });
        return result;
    }

    // 一覧反映行をバックエンドへ送り、通貨単位と見積レートを補完する。
    function requestUsedMaterialCurrencyRates(rows, onSuccess) {
        if (!Array.isArray(rows) || rows.length === 0) {
            onSuccess([]);
            return;
        }

        fnc.current.postaxios(
            controller + "/GetUsedMaterialCurrencyRates",
            {
                controller: controller,
                rowdata: rows,
                others: { date: usedMaterialRateDate() }
            },
            {
                onSuccess: function (data) {
                    const resolvedRows = Array.isArray(data?.rowdata) ? data.rowdata : rows;
                    onSuccess(resolvedRows);
                },
                onError: function () {
                    fnc.current.warnmsg("通貨単位または見積レートを取得できませんでした。");
                }
            },
            true
        );
    }

    // 一覧反映結果を再計算して使用副資材一覧へ表示する。
    function applyReflectedUsedMaterialRows(usedPanel, rows) {
        // 一覧反映では、ロス込数量を先に計算し、その結果を使って金額・金額(外)を計算する。
        const calculatedRows = (Array.isArray(rows) ? rows : []).map(row => recalculateUsedMaterialRow(row, "REFLECT"));

        rerenderUsedMaterialGrid(usedPanel, calculatedRows);
        fnc.current.modify(true);
        fnc.current.success("使用副資材一覧に反映しました。");
    }

    // 副資材パネルの入力を使用副資材一覧へ集約し、通貨・レート取得後に反映する。
    function ReflectUsedAuxMaterials() {
        // 一覧反映ボタン押下時点で画面に表示・編集中の内容を、まず内部保持データへ退避する。
        // そのうえで、表示中の組み合わせだけでなく、保持済みの全アイテム+カラー/グループを一覧化する。
        captureDisplayedAuxRows("ReflectUsedAuxMaterials");

        const usedPanel = findUsedAuxMaterialPanel();
        if (isEmpty(usedPanel)) {
            fnc.current.warnmsg("使用副資材一覧のパネルが設定されていません。s_logp/s_layoutにD_SSDZMの明細パネルを追加してください。");
            return;
        }

        const currentRows = GridData(usedPanel);
        const currentMap = createExistingUsedMaterialMap(currentRows);
        const materials = collectAuxMaterials(false);
        let rows = [];
        // 集約した副資材を表示順の行ID付きで使用副資材一覧行へ変換する。
        materials.forEach((material, index) => {
            const oldRow = currentMap[material.code] || {};
            const materialName = normalizeCode(material.name);
            // EntryGridAr / ag-grid 側では rowid や key を行識別子として扱うことがある。
            // 一覧反映で新規生成した行がすべて同じ/空の識別子になると、rowData は複数件でも
            // グリッド上では同一行として潰れて 1 行だけ表示されるため、副資材品番ベースの一意キーを付与する。
            const rowIdentity = "AUXMATBULK_USED_" + String(index + 1).padStart(4, "0") + "_" + material.code;
            rows.push({
                ...oldRow,
                key: rowIdentity,
                rowid: rowIdentity,
                __AUXMATBULK_ROWID: rowIdentity,
                SSDZM_FUZOKU_HINBAN: material.code,
                SSDZM_FUZOKU_HINBAN_cd: material.code,
                SSDZM_FUZOKU_HINBAN_nm: materialName,
                SSDZM_FUZOKU_NM: materialName,
                FZK_FUZOKU_NM: materialName,
                SSDZM_TORKUBUN: isEmpty(oldRow.SSDZM_TORKUBUN) ? "1" : oldRow.SSDZM_TORKUBUN,
                SSDZM_TORCODE: material.sourceTorCode,
                SSDZM_TORSUBCODE: isEmpty(oldRow.SSDZM_TORSUBCODE) ? "00000" : oldRow.SSDZM_TORSUBCODE,
                SSDZM_FUSIZAIKBN: material.kbn,
                __SOURCE_BRAND: material.sourceBrandCode,
                SSDZM_YOJAKUKOSU: isEmpty(oldRow.SSDZM_YOJAKUKOSU) ? 1 : oldRow.SSDZM_YOJAKUKOSU,
                SSDZM_LOSSRITU: isEmpty(oldRow.SSDZM_LOSSRITU) ? 0 : oldRow.SSDZM_LOSSRITU,
                SSDZM_LSURYO: isEmpty(oldRow.SSDZM_LSURYO) ? 1 : oldRow.SSDZM_LSURYO,
                SSDZM_SIKYUKBN: isEmpty(oldRow.SSDZM_SIKYUKBN) ? "" : oldRow.SSDZM_SIKYUKBN,
                __SOURCE_LABEL: material.label,
                __SOURCE_ITEM: material.sourceItem,
                __SOURCE_COLOR: material.sourceColor,
                __SOURCE_GROUP: material.sourceGroup
            });
        });

        // 一覧反映時は、各品番に対応する M_FZK.FZK_CUR と、同通貨の M_CUR 見積レートを
        // DBから取得してから使用副資材一覧へ表示する。
        rows = (Array.isArray(rows) ? rows : []).map(row => recalculateUsedMaterialRow(row, "REFLECT"));
        requestUsedMaterialCurrencyRates(rows, resolvedRows => {
            applyReflectedUsedMaterialRows(usedPanel, resolvedRows);
        });
    }

    // 入力したロス率を使用副資材一覧の全行へ設定し、計算項目を更新する。
    function ApplyLossRateToUsedMaterials() {
        const usedPanel = findUsedAuxMaterialPanel();
        if (isEmpty(usedPanel)) {
            fnc.current.warnmsg("使用副資材一覧のパネルが設定されていません。");
            return;
        }
        const lossRate = normalizeCode(bulkLossRateInputRef.current?.value);
        if (lossRate === "") {
            fnc.current.warnmsg("ロス率の一括設定値が入力されていません。");
            return;
        }
        const rows = currentUsedRows();
        if (!Array.isArray(rows) || rows.length === 0) {
            fnc.current.warnmsg("使用副資材一覧にデータがありません。先に一覧反映してください。");
            return;
        }
        const nextRows = rows.map(row =>
            recalculateUsedMaterialRow(
                { ...row, [USED_MATERIAL_LOSS_RATE_FIELD]: lossRate },
                USED_MATERIAL_LOSS_RATE_FIELD
            )
        );
        rerenderUsedMaterialGrid(usedPanel, nextRows);
        // 使用副資材一覧グリッドだけを更新する。画面全体の再描画は行わない。
        fnc.current.modify(true);
        fnc.current.success("ロス率を一括設定しました。");
    }

    // 選択した支給区分を使用副資材一覧の全行へ設定する。
    function ApplySikyuKbnToUsedMaterials() {
        const usedPanel = findUsedAuxMaterialPanel();
        if (isEmpty(usedPanel)) {
            fnc.current.warnmsg("使用副資材一覧のパネルが設定されていません。");
            return;
        }
        const selection = normalizeBulkSikyuKbnSelection(undefined, false);
        const sikyuKbn = selection.code;
        if (sikyuKbn === "") {
            fnc.current.warnmsg("支給区分の一括設定値が入力されていません。");
            return;
        }
        const sikyuKbnNm = selection.name;
        const rows = currentUsedRows();
        if (!Array.isArray(rows) || rows.length === 0) {
            fnc.current.warnmsg("使用副資材一覧にデータがありません。先に一覧反映してください。");
            return;
        }
        SetGridData(usedPanel, rows.map(row => ({
            ...row,
            SSDZM_SIKYUKBN: sikyuKbn,
            SSDZM_SIKYUKBN_cd: sikyuKbn,
            SSDZM_SIKYUKBN_nm: sikyuKbnNm
        })));
        RefreshGrid(usedPanel);
        rerender();
        fnc.current.modify(true);
        fnc.current.success("支給区分を一括設定しました。");
    }

    // 指定アイテムで未使用の次グループ番号を求める。
    function nextGroupNoForItem(itemCd, sourceRows = null) {
        const rows = Array.isArray(sourceRows) ? sourceRows : currentAuxRows();
        const groups = buildGroupOptions(rows, itemCd).map(v => Number(normalizeGroupNo(v))).filter(v => !Number.isNaN(v));
        // 01〜99を順番に調べ、指定アイテムで未使用の最小グループ番号を返す。
        for (let i = 1; i <= 99; i++) {
            if (!groups.includes(i)) return String(i).padStart(2, "0");
        }
        return "99";
    }

    // 追加・編集・複写の条件に応じてグループ操作ダイアログを初期化する。
    function openGroupDialog(mode, panelInfo, itemColorValue = "", groupValue = "", copyItemColorValue = "", copyGroupValue = "") {
        // グループ追加/編集/削除/複写は、現在表示中の入力内容も対象にするため、
        // ここで一度だけ明示的に内部保持へ退避する。currentAuxRows() では退避しない。
        captureDisplayedAuxRows("openGroupDialog");

        const auxPanel = !isEmpty(panelInfo) ? panelInfo : findAuxMaterialPanel();
        const rows = currentAuxRows(auxPanel);
        const selection = ensureAuxSelection(auxPanel);

        // React の state 更新は非同期なので、ボタン押下時は画面に表示中の値を引数で受け取って使う。
        // 引数が空の場合だけ、ensureAuxSelection() の補完値にフォールバックする。
        const requestedTargetValue = normalizeCode(itemColorValue) !== "" ? itemColorValue : selection.nextItemColor;
        const requestedTargetGroup = normalizeGroupNo(groupValue || selection.nextGroup || "");
        const targetSelection = resolveValidAuxSelection(rows, requestedTargetValue, requestedTargetGroup, "auto");
        const targetValue = targetSelection.itemColorValue;
        const target = parseItemColorValue(targetValue);
        const targetGroup = targetSelection.groupNo;

        const requestedSourceValue = normalizeCode(copyItemColorValue) !== "" ? copyItemColorValue : selection.nextCopyItemColor;
        const requestedSourceGroup = normalizeGroupNo(copyGroupValue || selection.nextCopyGroup || targetGroup);
        const sourceSelection = resolveValidAuxSelection(rows, requestedSourceValue, requestedSourceGroup, "auto");
        const sourceValue = sourceSelection.itemColorValue;
        const source = parseItemColorValue(sourceValue);
        const sourceGroup = sourceSelection.groupNo;

        if (target.itemCd === "") {
            fnc.current.warnmsg("アイテム+カラーコードが選択できません。副資材パネルの明細を確認してください。");
            return;
        }
        if (mode !== "add" && targetGroup === "") {
            fnc.current.warnmsg("グループが選択されていません。");
            return;
        }
        if (mode === "copy" && (source.itemCd === "" || sourceGroup === "")) {
            fnc.current.warnmsg("複写元アイテムと複写元グループを選択してください。");
            return;
        }

        const groupNo = mode === "add" ? nextGroupNoForItem(target.itemCd, rows) : targetGroup;
        const colorOptions = mode === "copy"
            ? buildColorOptionsForItem(source.itemCd, "", sourceGroup, rows)
            : buildColorOptionsForItem(target.itemCd, mode === "edit" ? groupNo : "", "", rows);

        setGroupDialogState({
            open: true,
            mode,
            title: mode === "add" ? "グループ追加" : mode === "edit" ? "グループ編集" : mode === "delete" ? "グループ削除" : "グループ複写",
            panelType: normalizeCode(auxPanel?.type),
            itemCd: target.itemCd,
            colorCd: target.colorCd,
            groupNo,
            sourceItemCd: source.itemCd,
            sourceColorCd: source.colorCd,
            sourceGroupNo: sourceGroup,
            colorOptions
        });
    }

    // グループ操作ダイアログを閉じる。
    function closeGroupDialog() {
        setGroupDialogState(prev => ({ ...prev, open: false }));
    }

    // グループ操作ダイアログ内のカラー選択状態を更新する。
    function updateGroupDialogColorChecked(colorCd, checked) {
        setGroupDialogState(prev => ({
            ...prev,
            colorOptions: (Array.isArray(prev.colorOptions) ? prev.colorOptions : []).map(item => normalizeCode(item.colorCd) === normalizeCode(colorCd) ? { ...item, checked } : item)
        }));
    }

    // 新しいグループ行の初期値に使う既存行または候補原本を取得する。
    function findAuxSeedRow(rows, itemCd, colorCd, groupNo = "") {
        const item = normalizeCode(itemCd);
        const color = normalizeCode(colorCd);
        const group = normalizeGroupNo(groupNo);
        const candidates = (Array.isArray(rows) ? rows : []).filter(row =>
            normalizeCode(row.SSDZ_ITMCITEMCD) === item
            && normalizeCode(row.SSDZ_COLORCD) === color
            && (group === "" || normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === group));

        // グループ追加・編集・複写のseedにはtype=102の行を優先する。
        // type=103の小物札固定行をseedにすると、小物札パネルの値が副資材パネルへ混入する。
        return candidates.find(row => normalizeType(row.__AUXMATBULK_PANEL_TYPE) === "") || candidates[0];
    }

    // 選択したカラーについて、新しいグループに属する副資材行を作成する。
    function createAuxGroupRow(rows, itemCd, colorCd, groupNo, seedGroupNo = "", inheritValues = false) {
        const seed = findAuxSeedRow(rows, itemCd, colorCd, seedGroupNo)
            || findAuxSeedRow(rows, itemCd, colorCd)
            || findAuxItemColorCatalogRow(itemCd, colorCd)
            || {};
        const row = inheritValues ? { ...seed } : {};
        // 新しいグループの基底行は必ずtype=102として作る。
        delete row.__AUXMATBULK_PANEL_TYPE;
        delete row.__AUXMATBULK_SLOT;
        delete row.rowid;
        row.SSDZ_ITMCITEMCD = normalizeCode(itemCd);
        row.SSDZ_COLORCD = normalizeCode(colorCd);
        row.SSDZ_FUKUSIZAICOLORGRP = normalizeGroupNo(groupNo);
        row.SSDZ_TORCODE = normalizeCode(seed.SSDZ_TORCODE || entrydataRef.current?.SSDZ_TORCODE);

        // 新規グループ行は inheritValues=false の場合、seed の値を自動継承しない。
        // 品番検索の絞り込みに使うブランドコードは共通キーとして明示的に引き継ぐ。
        const brandCode = normalizeCode(seed.PDT_BRDCODE);
        row.PDT_BRDCODE = brandCode;
        row.PDT_BRDCODE_cd = brandCode;
        if (!isEmpty(seed.PDT_BRDCODE_nm)) row.PDT_BRDCODE_nm = seed.PDT_BRDCODE_nm;

        if (!isEmpty(seed.SSDZ_NO)) row.SSDZ_NO = seed.SSDZ_NO;
        if (!isEmpty(seed.SSDZ_OPPICD)) row.SSDZ_OPPICD = seed.SSDZ_OPPICD;
        if (!isEmpty(seed.SSDZ_COLORCD_nm)) row.SSDZ_COLORCD_nm = seed.SSDZ_COLORCD_nm;
        if (!isEmpty(seed.SSDZ_ITMCITEMCD_nm)) row.SSDZ_ITMCITEMCD_nm = seed.SSDZ_ITMCITEMCD_nm;
        return row;
    }

    // ダイアログ内容に従い、グループ追加・編集・複写を内部保持データへ反映する。
    function commitGroupDialog() {
        const auxPanel = findAuxMaterialPanel();
        if (isEmpty(auxPanel)) {
            fnc.current.warnmsg("副資材パネルが設定されていません。");
            return;
        }

        const rows = currentAuxRows(auxPanel);
        const mode = groupDialogState.mode;
        const itemCd = normalizeCode(groupDialogState.itemCd);
        const groupNo = normalizeGroupNo(groupDialogState.groupNo);
        const checkedColors = (Array.isArray(groupDialogState.colorOptions) ? groupDialogState.colorOptions : [])
            .filter(item => item.checked)
            .map(item => normalizeCode(item.colorCd))
            .filter(value => value !== "");
        if (mode !== "delete" && checkedColors.length === 0) {
            fnc.current.warnmsg("対象カラーを選択してください。");
            return;
        }

        const currentItemColor = selectedItemColorRef.current || selectedItemColor || makeItemColorValue(itemCd, groupDialogState.colorCd);
        let nextRows = [...rows];

        if (mode === "delete") {
            nextRows = nextRows.filter(row => !(
                normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
                && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
            ));
        } else if (mode === "edit") {
            const checkedSet = new Set(checkedColors);
            // 対象外になったカラーだけを、基底行・固定行ともに削除する。
            // 残ったカラーの入力内容は保持する。
            nextRows = nextRows.filter(row => !(
                normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
                && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
                && !checkedSet.has(normalizeCode(row.SSDZ_COLORCD))
            ));
            // 選択された各カラーについて、新しいグループ行を作成する。
            checkedColors.forEach(colorCd => {
                const hasBaseRow = baseAuxRows(nextRows).some(row =>
                    normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
                    && normalizeCode(row.SSDZ_COLORCD) === colorCd
                    && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
                );
                if (!hasBaseRow) nextRows.push(createAuxGroupRow(rows, itemCd, colorCd, groupNo, "", false));
            });
        } else if (mode === "add") {
            checkedColors.forEach(colorCd => {
                const exists = baseAuxRows(nextRows).some(row =>
                    normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
                    && normalizeCode(row.SSDZ_COLORCD) === colorCd
                    && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
                );
                if (!exists) nextRows.push(createAuxGroupRow(rows, itemCd, colorCd, groupNo, "", false));
            });
        } else if (mode === "copy") {
            const sourceItemCd = normalizeCode(groupDialogState.sourceItemCd);
            const sourceGroupNo = normalizeGroupNo(groupDialogState.sourceGroupNo);
            checkedColors.forEach(colorCd => {
                nextRows = nextRows.filter(row => !(
                    normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd
                    && normalizeCode(row.SSDZ_COLORCD) === colorCd
                    && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === groupNo
                ));

                const sourceRows = rows.filter(row =>
                    normalizeCode(row.SSDZ_ITMCITEMCD) === sourceItemCd
                    && normalizeCode(row.SSDZ_COLORCD) === colorCd
                    && normalizeGroupNo(row.SSDZ_FUKUSIZAICOLORGRP) === sourceGroupNo
                );
                if (sourceRows.length === 0) {
                    nextRows.push(createAuxGroupRow(rows, itemCd, colorCd, groupNo, "", false));
                    return;
                }
                const targetSeed = findAuxSeedRow(rows, itemCd, colorCd)
                    || findAuxItemColorCatalogRow(itemCd, colorCd)
                    || baseAuxRows(rows).find(row => normalizeCode(row.SSDZ_ITMCITEMCD) === itemCd)
                    || {};
                // 複写元グループの全パネル行を新しいグループ番号へ複製する。
                sourceRows.forEach(sourceRow => {
                    const copy = { ...sourceRow };
                    copy.SSDZ_ITMCITEMCD = itemCd;
                    copy.SSDZ_COLORCD = colorCd;
                    copy.SSDZ_FUKUSIZAICOLORGRP = groupNo;
                    ["SSDZ_NO", "SSDZ_OPPICD", "SSDZ_TORCODE", "PDT_BRDCODE"].forEach(key => {
                        if (targetSeed[key] !== undefined) copy[key] = targetSeed[key];
                    });
                    delete copy.key;
                    delete copy.rowid;
                    nextRows.push(copy);
                });
            });
        }

        nextRows = dedupeAuxRows(nextRows);
        auxAllRowsRef.current = nextRows;
        auxAllRowsInitializedRef.current = true;

        let resolved;
        if (mode === "delete") {
            resolved = resolveSelectionAfterGroupDelete(nextRows, itemCd, groupNo, currentItemColor);
        } else {
            resolved = resolveValidAuxSelection(nextRows, currentItemColor, groupNo, "mutation");
        }
        applyResolvedAuxSelection(resolved);

        const copyResolved = resolveValidAuxSelection(nextRows, copyItemColor || resolved.itemColorValue, copyGroup || resolved.groupNo, "auto");
        setCopyItemColor(copyResolved.itemColorValue);
        setCopyGroup(copyResolved.groupNo);

        closeGroupDialog();
        fnc.current.modify(true);
    }

    // ドラッグ操作後のパネル順序をstateへ反映する。
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));

    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        // ダイアログに表示するカラー候補を1件ずつチェックボックスへ変換する。
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}>
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    // パネル種別に応じてEntryBaseまたはEntryGridArを描画する。
    function Contents(props) {
        if (props.panel.id === BASE_PANEL_ID) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} key={props.panel.type === AUX_MATERIAL_PANEL_TYPE ? `aux-base-${auxBaseRenderKey}` : baseid}>
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={(id, value, edit) => ValueChanged(id, value, edit, props.panel.type)}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.grid) {
            const gridIndex = GridIndex(props.panel);
            // 初回表示時に LoadData 内で gridlist が未反映だった場合でも、
            // D_SSDZ 系パネルには選択中アイテム+カラー+グループの行を渡す。
            try {
                if (isAuxMaterialInputPanel(props.panel) && gridIndex !== -1) {
                    const currentRows = griddataRefs.current[gridIndex]?.current;
                    const selectedRows = selectedRowsForPanel(props.panel, getSelectedAuxRows());
                    if ((!Array.isArray(currentRows) || currentRows.length === 0) && selectedRows.length !== 0) {
                        if (isEmpty(griddataRefs.current[gridIndex])) griddataRefs.current[gridIndex] = createRef();
                        griddataRefs.current[gridIndex].current = selectedRows.map(row => ({ ...row }));
                    }
                }
            } catch (err) {
                console.warn("[AuxMatBulk] initial selected rows apply skipped", props.panel, err);
            }
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[gridIndex]}
                    columnRef={gridcolRefs.current[gridIndex]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={(params) => GridValueChanged(params, props.panel)}
                    RowValueChanged={(columnId, rows) => GridRowsValueChanged(columnId, rows, props.panel)}
                    RemoveRow={() => storeRowData(props.panel)}
                    formid={formid}
                    panel={props.panel}
                    AutoAddRow={isFixedAuxMaterialGridPanel(props.panel) ? false : undefined}
                    rowContext={isRowOperationLockedPanel(props.panel) ? 1 : undefined}
                    QueryAddRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                    QueryInsertRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                    QueryRemoveRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                />
            );
        }
        return null;
    }

    // 支給区分一括設定用の入力欄を描画する。
    function renderBulkSikyuKbnInput(inputStyle) {
        const col = bulkSikyuKbnColumn();

        // type=107/AUXMATBULK_SIKYUKBN_BULK が未設定の環境でも動作確認できるよう、
        // 最低限は従来のテキスト入力にフォールバックする。
        if (isEmpty(col)) {
            return <input value={bulkSikyuKbn} onChange={(e) => setBulkSikyuKbnSelection(e.target.value, true)} style={inputStyle} />;
        }

        return (
            <div style={{ minWidth: 190, width: 260, height: 30, display: "inline-flex", alignItems: "center", border: "1px solid #c9c9c9", borderRadius: 2, padding: "0 4px", backgroundColor: "#fff" }}>
                <EntryInput
                    key={`bulk-sikyu-${bulkSikyuKbn}`}
                    fnc={fnc}
                    def={{ ...col, locked: false }}
                    dataRef={bulkControlDataRef}
                    textfields={(Array.isArray(textfieldsall) ? textfieldsall : []).concat(Array.isArray(textfields) ? textfields : [])}
                    ValueChanged={BulkSikyuKbnValueChanged}
                />
            </div>
        );
    }

    // 使用副資材一覧の一覧反映・一括設定ツールバーを描画する。
    function renderUsedAuxMaterialToolbar() {
        const wrapStyle = { display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 8, flexWrap: "wrap", marginBottom: 8 };
        const inputStyle = { height: 28, border: "1px solid #c9c9c9", borderRadius: 2, padding: "0 6px", width: 80, backgroundColor: "#fff", fontSize: 12 };
        const greenButtonStyle = { minWidth: 96, height: 30, padding: "0 12px", color: "#fff", backgroundColor: "#42b54f", borderRadius: 4, display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 1.2, boxShadow: "none", textTransform: "none", fontWeight: 600 };
        return (
            <div style={wrapStyle}>
                <Button type="button" size="small" variant="contained" style={greenButtonStyle} onClick={ReflectUsedAuxMaterials}>一覧反映</Button>
                <input ref={bulkLossRateInputRef} defaultValue="" style={inputStyle} inputMode="decimal" aria-label="ロス率一括設定値" />
                <Button type="button" size="small" variant="contained" style={greenButtonStyle} onClick={ApplyLossRateToUsedMaterials}>ロス率一括設定</Button>
                {renderBulkSikyuKbnInput(inputStyle)}
                <Button type="button" size="small" variant="contained" style={greenButtonStyle} onClick={ApplySikyuKbnToUsedMaterials}>支給区分一括設定</Button>
            </div>
        );
    }

    // 副資材パネルの選択ドロップダウンとグループ操作ボタンを描画する。
    function renderAuxMaterialGroupToolbar(panelInfo) {
        const selection = ensureAuxSelection(panelInfo);
        const boxStyle = { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 8 };
        const selectStyle = { height: 30, border: "1px solid #c9c9c9", borderRadius: 3, padding: "0 6px", backgroundColor: "#fff", minWidth: 150, fontSize: 12 };
        const iconButtonStyle = { width: 20, height: 20, padding: 0, borderRadius: 2, border: "1px solid #8e8e8e", backgroundColor: "#7f8b8f", color: "#fff" };
        const copyButtonStyle = { minWidth: 52, height: 28, borderRadius: 8, padding: "0 12px", color: "#fff", backgroundColor: "#42b54f", display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 1.2, boxShadow: "none", textTransform: "none", fontWeight: 600 };
        const currentItemColor = selection.nextItemColor;
        const currentGroup = normalizeGroupNo(selection.nextGroup);
        const currentCopyItemColor = selection.nextCopyItemColor;
        const currentCopyGroup = normalizeGroupNo(selection.nextCopyGroup);
        const targetItem = parseItemColorValue(currentItemColor).itemCd;
        const targetGroups = buildGroupOptions(selection.rows, targetItem);
        const sourceItem = parseItemColorValue(currentCopyItemColor).itemCd;
        const sourceGroups = buildGroupOptions(selection.rows, sourceItem);
        return (
            <div style={boxStyle}>
                <select value={currentItemColor} onChange={(e) => {
                    setAuxSelection(e.target.value, currentGroup, "itemColor");
                }} style={selectStyle}>
                    {selection.itemColorOptions.map(o => <option key={"item_color_" + o.value} value={o.value}>{o.label}</option>)}
                </select>
                <select value={currentGroup} onChange={(e) => setAuxSelection(currentItemColor, normalizeGroupNo(e.target.value), "group")} style={{ ...selectStyle, minWidth: 110 }}>
                    {currentGroup === "" || targetGroups.length === 0 ? <option value="">未設定</option> : null}
                    {targetGroups.map(v => <option key={"group_" + v} value={v}>{groupNoToLabel(v)}</option>)}
                </select>
                <IconButton type="button" size="small" style={iconButtonStyle} title="グループ追加" onClick={() => openGroupDialog("add", panelInfo, currentItemColor, currentGroup, currentCopyItemColor, currentCopyGroup)}><Icon style={{ fontSize: 14 }}>add</Icon></IconButton>
                <IconButton type="button" size="small" style={iconButtonStyle} disabled={currentGroup === ""} title="グループ削除" onClick={() => openGroupDialog("delete", panelInfo, currentItemColor, currentGroup, currentCopyItemColor, currentCopyGroup)}><Icon style={{ fontSize: 14 }}>remove</Icon></IconButton>
                <IconButton type="button" size="small" style={iconButtonStyle} disabled={currentGroup === ""} title="グループ編集" onClick={() => openGroupDialog("edit", panelInfo, currentItemColor, currentGroup, currentCopyItemColor, currentCopyGroup)}><Icon style={{ fontSize: 14 }}>edit</Icon></IconButton>
                <span style={{ fontSize: 12, color: "#555", marginLeft: 20 }}>複写元アイテム</span>
                <select value={currentCopyItemColor} onChange={(e) => {
                    setCopySelection(e.target.value, currentCopyGroup, "itemColor");
                }} style={selectStyle}>
                    {selection.itemColorOptions.map(o => <option key={"copy_item_color_" + o.value} value={o.value}>{o.label}</option>)}
                </select>
                <span style={{ fontSize: 12, color: "#555" }}>複写元グループ</span>
                <select value={currentCopyGroup} onChange={(e) => setCopySelection(currentCopyItemColor, normalizeGroupNo(e.target.value), "group")} style={{ ...selectStyle, minWidth: 110 }}>
                    {currentCopyGroup === "" || sourceGroups.length === 0 ? <option value="">未設定</option> : null}
                    {sourceGroups.map(v => <option key={"copy_group_" + v} value={v}>{groupNoToLabel(v)}</option>)}
                </select>
                <Button type="button" size="small" variant="contained" style={copyButtonStyle} onClick={() => openGroupDialog("copy", panelInfo, currentItemColor, currentGroup, currentCopyItemColor, currentCopyGroup)}>複写</Button>
            </div>
        );
    }

    // パネルtypeに対応する画面固有の操作領域を描画する。
    function renderPanelActionArea(p) {
        if (isUsedAuxMaterialPanel(p)) return renderUsedAuxMaterialToolbar();
        if (isAuxMaterialPanel(p)) return renderAuxMaterialGroupToolbar(p);
        return null;
    }

    // グループ追加・編集・複写用のモーダルダイアログを描画する。
    function renderGroupActionDialog() {
        if (!groupDialogState.open) return null;
        const dialogStyle = { position: "fixed", inset: 0, zIndex: 4000, backgroundColor: "rgba(0,0,0,0.35)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 };
        const paperStyle = { width: "min(720px, 96vw)", maxHeight: "90vh", overflow: "auto", padding: 20 };
        const fieldRowStyle = { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 };
        const fieldLabelStyle = { minWidth: 86, fontSize: 12, color: "#444" };
        const inputStyle = { height: 30, border: "1px solid #c9c9c9", borderRadius: 3, padding: "0 8px", minWidth: 140, backgroundColor: "#f7f7f7" };
        const tableWrapStyle = { marginTop: 12, border: "1px solid #d9d9d9", borderRadius: 4, overflow: "hidden" };
        const tableStyle = { width: "100%", borderCollapse: "collapse", tableLayout: "fixed" };
        const tableHeadCellStyle = { fontSize: 12, fontWeight: 600, color: "#444", textAlign: "left", padding: "6px 8px", backgroundColor: "#f2f2f2", borderBottom: "1px solid #d9d9d9" };
        const tableBodyCellStyle = { fontSize: 12, color: "#333", padding: "6px 8px", borderBottom: "1px solid #ececec", verticalAlign: "middle" };
        const footerStyle = { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 };
        const isDelete = groupDialogState.mode === "delete";
        const isCopy = groupDialogState.mode === "copy";
        return (
            <div style={dialogStyle} onClick={closeGroupDialog}>
                <Paper elevation={3} style={paperStyle} onClick={(e) => e.stopPropagation()}>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>{groupDialogState.title || "グループ操作"}</div>
                    {isCopy ? (
                        <>
                            <div style={fieldRowStyle}><span style={fieldLabelStyle}>複写元</span><input type="text" value={`${groupDialogState.sourceItemCd} / ${groupNoToLabel(groupDialogState.sourceGroupNo)}`} readOnly style={inputStyle} /></div>
                            <div style={fieldRowStyle}><span style={fieldLabelStyle}>複写先</span><input type="text" value={`${groupDialogState.itemCd} / ${groupNoToLabel(groupDialogState.groupNo)}`} readOnly style={inputStyle} /></div>
                        </>
                    ) : (
                        <div style={fieldRowStyle}>
                            <span style={fieldLabelStyle}>Group</span>
                            <input type="text" value={groupDialogState.mode === "add" ? groupDialogState.groupNo : groupNoToLabel(groupDialogState.groupNo)} readOnly={groupDialogState.mode !== "add"} maxLength={2} onChange={(e) => {
                                const value = String(e.target.value ?? "").replace(/[^\d]/g, "").slice(0, 2);
                                setGroupDialogState(prev => ({ ...prev, groupNo: value }));
                            }} style={inputStyle} />
                        </div>
                    )}
                    {!isDelete ? (
                        <div style={tableWrapStyle}>
                            <table style={tableStyle}>
                                <thead><tr><th style={{ ...tableHeadCellStyle, width: 56 }}>選択</th><th style={{ ...tableHeadCellStyle, width: 120 }}>カラー</th><th style={tableHeadCellStyle}>カラー名</th></tr></thead>
                                <tbody>
                                    {(Array.isArray(groupDialogState.colorOptions) ? groupDialogState.colorOptions : []).length === 0 ? (
                                        <tr><td colSpan={3} style={tableBodyCellStyle}></td></tr>
                                    ) : groupDialogState.colorOptions.map(item => {
                                        const colorCd = normalizeCode(item.colorCd);
                                        return (
                                            <tr key={colorCd}>
                                                <td style={tableBodyCellStyle}><input type="checkbox" checked={!!item.checked} onChange={(e) => updateGroupDialogColorChecked(colorCd, e.target.checked)} /></td>
                                                <td style={tableBodyCellStyle}>{colorCd}</td>
                                                <td style={tableBodyCellStyle}>{normalizeCode(item.colorName)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : <div style={{ fontSize: 13, color: "#444", marginTop: 8 }}>選択中のグループを削除します。よろしいですか？</div>}
                    <div style={footerStyle}>
                        <Button type="button" size="small" variant="contained" onClick={closeGroupDialog}>Cancel</Button>
                        <Button type="button" size="small" variant="contained" color="primary" onClick={commitGroupDialog}>実行</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    // パネル種別に応じてEntryBaseまたはEntryGridArを描画する。
    function Contents(props) {
        if (props.panel.id === BASE_PANEL_ID) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} key={props.panel.type === AUX_MATERIAL_PANEL_TYPE ? `aux-base-${auxBaseRenderKey}` : baseid}>
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={(id, value, edit) => ValueChanged(id, value, edit, props.panel.type)}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.grid) {
            const gridIndex = GridIndex(props.panel);
            // 初回表示時に LoadData 内で gridlist が未反映だった場合でも、
            // D_SSDZ 系パネルには選択中アイテム+カラー+グループの行を渡す。
            try {
                if (isAuxMaterialInputPanel(props.panel) && gridIndex !== -1) {
                    const currentRows = griddataRefs.current[gridIndex]?.current;
                    const selectedRows = selectedRowsForPanel(props.panel, getSelectedAuxRows());
                    if ((!Array.isArray(currentRows) || currentRows.length === 0) && selectedRows.length !== 0) {
                        if (isEmpty(griddataRefs.current[gridIndex])) griddataRefs.current[gridIndex] = createRef();
                        griddataRefs.current[gridIndex].current = selectedRows.map(row => ({ ...row }));
                    }
                }
            } catch (err) {
                console.warn("[AuxMatBulk] initial selected rows apply skipped", props.panel, err);
            }
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[gridIndex]}
                    columnRef={gridcolRefs.current[gridIndex]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={(params) => GridValueChanged(params, props.panel)}
                    RowValueChanged={(columnId, rows) => GridRowsValueChanged(columnId, rows, props.panel)}
                    RemoveRow={() => storeRowData(props.panel)}
                    formid={formid}
                    panel={props.panel}
                    AutoAddRow={isFixedAuxMaterialGridPanel(props.panel) ? false : undefined}
                    rowContext={isRowOperationLockedPanel(props.panel) ? 1 : undefined}
                    QueryAddRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                    QueryInsertRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                    QueryRemoveRow={isRowOperationLockedPanel(props.panel) ? (() => false) : undefined}
                />
            );
        }
        return null;
    }

    // 画面全体のMasterLayout、パネル一覧、設定ダイアログを構成する。
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            key={p.id + "_" + p.type + "_" + i}
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== BASE_PANEL_ID || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}>
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}>
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                {renderPanelActionArea(p)}
                                <Contents panel={p} />
                            </Paper>
                        </Box>
                    );
                })}
                {renderGroupActionDialog()}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <AGFunc ref={AGRef} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={false}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                entrycallback={MenuAction}
                usecondition={false}
                entryform={true}
                suppressaction={suppressaction}
                primarykey={primarykeys}
                show={Show}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"}>
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 54, left: 210 }}>
                        <Paper component="ul" elevation={0} style={{ backgroundColor: "transparent", width: panelnavwidth(), display: 'flex', flexWrap: 'wrap', listStyle: 'none', padding: 4, margin: 0 }}>
                            <SortablePanelSelector axis={"x"} items={panel} onSortEnd={onPanelSortEnd} distance={2} />
                        </Paper>
                    </div>
                </div>
                : null}
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
